(function () {
  // Detail colours are independent of Shopify's terrain/body variants.
  const DETAIL_COLOURS = {
    grey: {label:'Grey', hex:'#858585'},
    black: {label:'Black', hex:'#202020'},
    white: {label:'White', hex:'#f2f0e9'},
    green: {label:'Green', hex:'#52754b'},
    red: {label:'Red', hex:'#dc332b'},
    gold: {label:'Gold', hex:'#c68a36'},
    brown: {label:'Brown', hex:'#79523a'},
    blue: {label:'Blue', hex:'#3275b9'},
    beige: {label:'Beige', hex:'#d3bf9b'}
  };
  function detailColour(key) {
    return Object.prototype.hasOwnProperty.call(DETAIL_COLOURS,key) ? key : 'red';
  }
  function detailColourSelect(value, label, onChange) {
    const field=document.createElement('label');
    field.className='ridge-detail-colour-field';
    const swatch=document.createElement('span');
    swatch.className='ridge-detail-colour-swatch';
    swatch.setAttribute('aria-hidden','true');
    const select=document.createElement('select');
    select.className='ridge-detail-colour-select';
    select.setAttribute('aria-label',label);
    Object.entries(DETAIL_COLOURS).forEach(([key,colour]) => {
      const option=document.createElement('option');
      option.value=key; option.textContent=colour.label; select.appendChild(option);
    });
    select.value=detailColour(value);
    swatch.style.backgroundColor=DETAIL_COLOURS[select.value].hex;
    select.addEventListener('change',() => {
      swatch.style.backgroundColor=DETAIL_COLOURS[select.value].hex;
      onChange(select.value);
    });
    field.append(swatch,select);
    return field;
  }

  function loadLeaflet(callback) {
    if (typeof L !== "undefined") {
      callback();
      return;
    }

    if (!document.querySelector('link[data-terrain-leaflet]')) {
      const css = document.createElement("link");
      css.rel = "stylesheet";
      css.href = "https://unpkg.com/leaflet@1.9.4/dist/leaflet.css";
      css.dataset.terrainLeaflet = "true";
      document.head.appendChild(css);
    }

    const existing = document.querySelector(
      'script[data-terrain-leaflet-js]'
    );

    if (existing) {
      existing.addEventListener(
        "load",
        callback,
        { once: true }
      );

      return;
    }

    const script = document.createElement("script");

    script.src =
      "https://unpkg.com/leaflet@1.9.4/dist/leaflet.js";

    script.dataset.terrainLeafletJs =
      "true";

    script.onload =
      callback;

    document.head.appendChild(
      script
    );
  }


  function installRotationFetchBridge() {
    if (
      window.__ridgeRotationFetchBridgeInstalled
    ) {
      return;
    }

    const originalFetch =
      window.fetch.bind(
        window
      );

    window.fetch =
      function (
        input,
        init
      ) {

        try {

          const url =
            typeof input === "string"
              ? input
              : input &&
                input.url
                ? input.url
                : "";

          const options =
            init
              ? { ...init }
              : {};


          if (
            (
              url.includes(
                "/terrain/start"
              )
              ||
              url.includes(
                "/terrain/commit"
              )
            )
            &&
            options.body
            &&
            window.selectedTerrain
          ) {

            const body =
              JSON.parse(
                options.body
              );


            body.rotation_degrees =
              Number(
                window
                  .selectedTerrain
                  .rotationDegrees
                ||
                0
              );


            body.corners =
              Array.isArray(
                window
                  .selectedTerrain
                  .corners
              )
                ? window
                    .selectedTerrain
                    .corners
                    .map(
                      function (
                        corner
                      ) {

                        return {
                          lat:
                            Number(
                              corner.lat
                            ),

                          lng:
                            Number(
                              corner.lng
                            )
                        };

                      }
                    )
                : null;


            options.body =
              JSON.stringify(
                body
              );
          }


          return originalFetch(
            input,
            options
          );


        } catch (
          error
        ) {

          return originalFetch(
            input,
            init
          );

        }

      };


    window.__ridgeRotationFetchBridgeInstalled =
      true;
  }


  function initialiseMap(
    wrapper
  ) {

    if (
      !wrapper
      ||
      wrapper.dataset.initialised ===
        "true"
    ) {
      return;
    }


    const mapElement =
      wrapper.querySelector(
        ".terrain-map"
      );


    if (
      !mapElement
    ) {
      return;
    }


    wrapper.dataset.initialised =
      "true";


    loadLeaflet(
      function () {

        createMap(
          wrapper,
          mapElement
        );

      }
    );
  }


  function createMap(
    wrapper,
    mapElement
  ) {

    installRotationFetchBridge();


    const map =
      L.map(
        mapElement,
        {
          center:
            [
              -41.2865,
              174.7762
            ],

          zoom:
            5
        }
      );


    const mapTileLayer = L.tileLayer(
      "https://tile.openstreetmap.org/{z}/{x}/{y}.png",
      {
        maxZoom:
          19,

        attribution:
          "&copy; OpenStreetMap contributors",
        className: "ridge-light-map-tiles"
      }
    ).addTo(
      map
    );

    // Map appearance changes only the tiles. The selected area, GPX paths,
    // marker and terrain request remain in the same Leaflet map instance.
    const cartoKey = (wrapper.dataset.cartoKey || "").trim();
    const cartoAttribution = '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>';
    const mapSkins = {
      light: cartoKey ? L.tileLayer(
        "https://basemaps.cartocdn.com/rastertiles/light_all/{z}/{x}/{y}.png?key=" + encodeURIComponent(cartoKey),
        { maxZoom:19, attribution:cartoAttribution }
      ) : mapTileLayer,
      dark: cartoKey ? L.tileLayer(
        "https://basemaps.cartocdn.com/rastertiles/dark_all/{z}/{x}/{y}.png?key=" + encodeURIComponent(cartoKey),
        { maxZoom:19, attribution:cartoAttribution }
      ) : L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
        maxZoom: 19, attribution: "&copy; OpenStreetMap contributors", className: "ridge-dark-map-tiles"
      }),
      satellite: L.tileLayer(
        "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
        { maxZoom: 19, attribution: "Imagery &copy; Esri and contributors" }
      )
    };
    if (cartoKey) {
      map.removeLayer(mapTileLayer);
      mapSkins.light.addTo(map);
    }
    const skinControl = document.createElement("div");
    skinControl.className = "ridge-map-skins";
    skinControl.setAttribute("role", "group");
    skinControl.setAttribute("aria-label", "Map appearance");
    skinControl.innerHTML = '<button type="button" data-skin="satellite">Satellite</button><button type="button" data-skin="dark">Dark</button><button type="button" data-skin="light">Light</button>';
    // Keep the ONE theme switch visible throughout the builder journey,
    // not inside the map panel (which hides on Size/Customize).
    const themeSlot = wrapper.querySelector(".ridge-studio-theme-slot");
    if (themeSlot) themeSlot.appendChild(skinControl);
    else mapElement.appendChild(skinControl);
    L.DomEvent.disableClickPropagation(skinControl);
    L.DomEvent.disableScrollPropagation(skinControl);
    let currentSkin = "light";
    skinControl.addEventListener("click", function (event) {
      const button = event.target.closest("button[data-skin]");
      if (!button || !mapSkins[button.dataset.skin]) return;
      const next = button.dataset.skin;
      wrapper.dataset.ridgeMapSkin = next;
      if (next !== currentSkin) {
        map.removeLayer(mapSkins[currentSkin]);
        mapSkins[next].addTo(map);
        // Keep drawn selection and GPX paths above the new basemap.
        mapSkins[next].bringToBack();
        currentSkin = next;
      }
      skinControl.querySelectorAll("button").forEach(function (item) {
        const selected = item.dataset.skin === next;
        item.classList.toggle("is-active", selected);
        item.setAttribute("aria-pressed", String(selected));
      });
    });
    skinControl.querySelector('[data-skin="light"]').click();


    setTimeout(
      function () {

        map.invalidateSize();

      },
      500
    );


    const searchInput =
      wrapper.querySelector(
        ".terrain-search-input"
      );

    const searchButton =
      wrapper.querySelector(
        ".terrain-search-button"
      );

    const selectButton =
      wrapper.querySelector(
        ".terrain-select-button"
      );

    const mapStep =
      wrapper.querySelector(
        ".terrain-map-step"
      );

    const sizeOptions =
      wrapper.querySelectorAll(
        ".terrain-size-option"
      );

    const sizeSelection =
      wrapper.querySelector(
        ".terrain-size-selection"
      );

    const sizeSummary =
      wrapper.querySelector(
        ".terrain-size-summary"
      );

    const selectedSizeOutput =
      wrapper.querySelector(
        ".terrain-selected-size"
      );

    const selectedPriceOutput =
      wrapper.querySelector(
        ".terrain-selected-price"
      );

    const emptyBox =
      wrapper.querySelector(
        ".terrain-empty"
      );

    const selectedBox =
      wrapper.querySelector(
        ".terrain-selected"
      );

    const previewButton =
      wrapper.querySelector(
        ".terrain-preview-button"
      );

    if (previewButton) {
      previewButton.textContent =
        "Generate preview";
    }

    // Show an actionable warning beside Generate preview if the pin is out of bounds.
    const markerPreviewWarning = document.createElement("div");
    markerPreviewWarning.className = "ridge-marker-preview-warning";
    markerPreviewWarning.setAttribute("role", "alert");
    markerPreviewWarning.hidden = true;
    markerPreviewWarning.innerHTML =
      '<strong>Move every marker inside the terrain box.</strong> ' +
      '<button type="button" class="ridge-marker-recentre">Centre invalid markers</button>';
    if (previewButton) previewButton.insertAdjacentElement("beforebegin", markerPreviewWarning);
    markerPreviewWarning.querySelector(".ridge-marker-recentre").addEventListener("click", function () {
      if (!selectedSize || !selectionCorners) return;
      terrainMarkers.forEach(entry => {
        if (!pinWithinSelection(entry)) centreTerrainMarker(entry);
      });
      updateInformation();
    });

    const widthOutput =
      wrapper.querySelector(
        ".terrain-width"
      );

    const heightOutput =
      wrapper.querySelector(
        ".terrain-height"
      );

    const areaOutput =
      wrapper.querySelector(
        ".terrain-area"
      );

    const northOutput =
      wrapper.querySelector(
        ".terrain-north"
      );

    const southOutput =
      wrapper.querySelector(
        ".terrain-south"
      );

    const eastOutput =
      wrapper.querySelector(
        ".terrain-east"
      );

    const westOutput =
      wrapper.querySelector(
        ".terrain-west"
      );


    let selectedSize =
      null;

    let selectedPrice =
      null;

    let modelWidthMm =
      null;

    let modelHeightMm =
      null;

    let orientation =
      "landscape";

    let heightMultiplier =
      1.5;

    let targetRatio =
      null;


    let drawing =
      false;

    let drawStartLatLng =
      null;


    let selectionPolygon =
      null;

    let selectionCorners =
      null;

    let selectionRotationDegrees =
      0;

    let cornerHandles =
      [];

    let centreHandle =
      null;

    let rotationHandle =
      null;

    let rotationLine =
      null;

    let resizeHintMarker =
      null;


    /*
     * =====================================================
     * SIMPLE FLOW + PERSISTENCE
     * =====================================================
     *
     * Searching for a place creates a correctly-shaped
     * starter box automatically. A manual drawing tool is
     * still available as a secondary option for customers
     * who want to draw their area themselves.
     *
     * The chosen size, orientation, height boost and map
     * selection are also saved locally so an accidental
     * refresh does not make them start again.
     */

    const stateKey =
      "ridgeTerrainConfiguratorStateV4:"
      +
      (wrapper.dataset.sectionId || "default");

    let lastSearchLatLng =
      null;

    // Up to 10 independently draggable physical terrain markers. The existing
    // Shopify Location Pin add-on stays NZ$5 TOTAL, not NZ$5 per marker.
    const MAX_TERRAIN_MARKERS = 10;
    let terrainMarkers = [];
    let nextTerrainMarkerId = 1;
    let pointControls = null;
    let pointMessage = null;
    let markerList = null;
    let addMarkerButton = null;
    // GPX is selected before generating a preview. The source XML is retained
    // only in this tab and sent to the server once the prepared DEM exists.
    let mapGpx = null;
    // Up to five GPX files are combined in the browser into one server-compatible
    // GPX document. Individual routes remain separate track segments.
    let mapGpxFiles = [];
    let nextGpxRouteId = 1;
    let gpxFileList = null;
    const MAX_GPX_FILES = 5;
    const MAX_GPX_BYTES = 10 * 1024 * 1024;
    const MAX_GPX_POINTS = 20000;
    const MAX_GPX_SEGMENTS = 60;
    let mapGpxLine = null;
    // Keep the full source GPX for STL generation; draw only a simplified
    // copy on an efficient Canvas layer (not a huge SVG path).
    const mapGpxRenderer = L.canvas({ padding: 0.3 });
    let gpxLoadVersion = 0;
    let gpxTileLoadHandler = null;
    let gpxTileLoadTimer = null;
    let gpxUploadControl = null;
    let gpxStatus = null;
    let gpxRemove = null;

    let restoringState =
      false;


    function readSavedState() {

      try {

        const raw =
          window.localStorage.getItem(
            stateKey
          );

        if (!raw) {
          return null;
        }

        const parsed =
          JSON.parse(raw);

        return parsed
          &&
          typeof parsed === "object"
            ? parsed
            : null;

      } catch (error) {

        return null;
      }
    }


    function saveState() {

      if (
        restoringState
        ||
        !selectedSize
      ) {
        return;
      }

      try {

        const centre =
          map.getCenter();

        window.localStorage.setItem(
          stateKey,
          JSON.stringify({
            selectedSize:
              selectedSize,

            orientation:
              orientation,

            heightMultiplier:
              heightMultiplier,

            searchText:
              searchInput
                ? searchInput.value
                : "",

            mapCentre:
              centre
                ? {
                    lat: Number(centre.lat),
                    lng: Number(centre.lng)
                  }
                : null,

            mapZoom:
              map.getZoom(),

            rotationDegrees:
              selectionRotationDegrees,

            // Save absolute geographic coordinates only. Once a marker is
            // placed, subsequent resizing/moving/rotating the box must never
            // change its latitude/longitude.
            markers: terrainMarkers.map(entry => ({
              lat: Number(entry.point.lat),
              lng: Number(entry.point.lng),
              colour: detailColour(entry.colour)
            })),

            corners:
              selectionCorners
                ? selectionCorners.map(
                    function (corner) {
                      return {
                        lat: Number(corner.lat),
                        lng: Number(corner.lng)
                      };
                    }
                  )
                : null
          })
        );

      } catch (error) {
        /* localStorage can be unavailable in private browsers. */
      }
    }


    function createStarterSelection(
      latLng,
      keepRotation
    ) {

      if (
        !selectedSize
        ||
        !targetRatio
        ||
        !latLng
      ) {
        return;
      }

      stopDrawing();

      const centre =
        map.latLngToLayerPoint(
          latLng
        );

      const mapSize =
        map.getSize();

      const maxWidth =
        Math.max(
          130,
          Math.min(
            260,
            mapSize.x * 0.34
          )
        );

      const maxHeight =
        Math.max(
          110,
          Math.min(
            220,
            mapSize.y * 0.30
          )
        );

      let width =
        maxWidth;

      let height =
        width /
        targetRatio;

      if (
        height >
        maxHeight
      ) {

        height =
          maxHeight;

        width =
          height *
          targetRatio;
      }

      const angle =
        keepRotation
          ? selectionRotationDegrees
            *
            Math.PI
            /
            180
          : 0;

      selectionRotationDegrees =
        keepRotation
          ? selectionRotationDegrees
          : 0;

      selectionCorners =
        buildCorners(
          centre,
          width,
          height,
          angle
        );

      updateSelectionLayers();

      createHandles();

      updateInformation();
    }


    function restoreSavedState() {

      const saved =
        readSavedState();

      if (
        !saved
        ||
        !saved.selectedSize
      ) {
        return;
      }

      const option =
        Array.from(
          sizeOptions
        ).find(
          function (item) {
            return item.dataset.size ===
              saved.selectedSize;
          }
        );

      if (!option) {
        return;
      }

      restoringState =
        true;

      try {

        sizeOptions.forEach(
          function (item) {
            item.classList.toggle(
              "selected",
              item === option
            );
          }
        );

        selectedSize =
          option.dataset.size;

        selectedPrice =
          Number(
            option.dataset.price
          );

        modelWidthMm =
          Number(
            option.dataset.modelWidth
          );

        modelHeightMm =
          Number(
            option.dataset.modelHeight
          );

        if (
          modelWidthMm ===
          modelHeightMm
        ) {

          orientation =
            "square";

          orientationControls.style.display =
            "none";

        } else {

          orientation =
            saved.orientation === "portrait"
              ? "portrait"
              : "landscape";

          orientationControls.style.display =
            "block";
        }

        updateTargetRatio();
        updateOrientationButtons();
        updateSizeSummary();

        sizeSummary.style.display =
          "grid";

        heightControls.style.display =
          "block";

        setHeightMultiplier(
          saved.heightMultiplier === undefined
            ? 1.5
            : Number(saved.heightMultiplier)
        );

        if (
          searchInput
          &&
          saved.searchText
        ) {
          searchInput.value =
            String(saved.searchText);
        }

        if (
          saved.mapCentre
          &&
          Number.isFinite(
            Number(saved.mapCentre.lat)
          )
          &&
          Number.isFinite(
            Number(saved.mapCentre.lng)
          )
        ) {

          map.setView(
            [
              Number(saved.mapCentre.lat),
              Number(saved.mapCentre.lng)
            ],
            Number.isFinite(
              Number(saved.mapZoom)
            )
              ? Number(saved.mapZoom)
              : map.getZoom(),
            {
              animate: false
            }
          );
        }

        // Restore all markers at their exact saved map coordinates. Older
        // saved marker entries with followsBox:true are treated as fixed too.
        // Keep compatibility with the previous single-marker state format.
        const oldMarker = saved.includePrintedPin ? [{
          lat: saved.locationPoint && saved.locationPoint.lat,
          lng: saved.locationPoint && saved.locationPoint.lng
        }] : [];
        const savedMarkers = Array.isArray(saved.markers) ? saved.markers : oldMarker;
        savedMarkers.slice(0, MAX_TERRAIN_MARKERS).forEach(record => {
          const lat = Number(record.lat), lng = Number(record.lng);
          const valid = Number.isFinite(lat) && Number.isFinite(lng)
            && lat >= -90 && lat <= 90 && lng >= -180 && lng <= 180;
          addTerrainMarker(valid ? L.latLng(lat, lng) : map.getCenter(), record.colour);
        });

        if (
          Array.isArray(
            saved.corners
          )
          &&
          saved.corners.length ===
            4
        ) {

          selectionCorners =
            saved.corners.map(
              function (corner) {
                return L.latLng(
                  Number(corner.lat),
                  Number(corner.lng)
                );
              }
            );

          selectionRotationDegrees =
            Number(saved.rotationDegrees)
            ||
            0;

          createHandles();
          updateInformation();

        } else if (saved.mapCentre) {
          createStarterSelection(map.getCenter(), false);
        }
        updatePointControls();

      } finally {

        restoringState =
          false;
      }

      saveState();
    }


    function addStyles() {

      if (
        document.getElementById(
          "terrain-extra-control-styles"
        )
      ) {
        return;
      }


      const style =
        document.createElement(
          "style"
        );


      style.id =
        "terrain-extra-control-styles";


      style.textContent = `

        .terrain-orientation-controls,
        .terrain-height-controls {
          margin-top: 18px;
          padding: 18px;
          background: #f7f7f7;
          border-radius: 6px;
        }


        .terrain-orientation-title,
        .terrain-height-title {
          display: block;
          margin-bottom: 10px;
          font-size: 15px;
          font-weight: 600;
          color: #444;
        }


        .terrain-orientation-buttons {
          display: flex;
          gap: 10px;
        }


        .terrain-orientation-button {
          flex: 1;
          padding: 11px 18px;
          background: #fff;
          color: #111;
          border: 1px solid #ccc;
          border-radius: 5px;
          cursor: pointer;
          font-size: 14px;
        }


        .terrain-orientation-button:hover {
          border-color: #777;
        }


        .terrain-orientation-button.selected {
          border: 2px solid #111;
          padding: 10px 17px;
          font-weight: 600;
        }


        .terrain-height-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 15px;
          margin-bottom: 14px;
        }


        .terrain-height-title {
          margin: 0;
        }


        .terrain-height-value {
          font-size: 18px;
          font-weight: 700;
          color: #111;
          min-width: 46px;
          text-align: right;
        }


        .terrain-height-slider {
          width: 100%;
          cursor: pointer;
          accent-color: #111;
        }


        .terrain-height-labels {
          display: flex;
          justify-content: space-between;
          margin-top: 7px;
          font-size: 11px;
          color: #777;
        }


        .terrain-height-description {
          margin: 12px 0 0;
          font-size: 14px;
          line-height: 1.55;
          color: #5f5f5f;
        }


        .terrain-search-input-wrapper {
          position: relative;
          flex: 1 1 auto;
          min-width: 0;
        }


        .terrain-search-input-wrapper
        .terrain-search-input {
          width: 100% !important;
        }


        .terrain-search-suggestions {
          display: none;
          position: absolute;
          top: calc(100% + 6px);
          left: 0;
          right: 0;
          z-index: 10000;
          overflow: hidden;
          background: #fff;
          border: 1px solid #d8d8d8;
          border-radius: 6px;
          box-shadow:
            0 10px 30px
            rgba(
              0,
              0,
              0,
              0.12
            );
        }


        .terrain-search-suggestions.is-open {
          display: block;
        }


        .terrain-search-suggestion {
          display: block;
          width: 100%;
          padding: 11px 13px;
          margin: 0;
          background: #fff;
          border: 0;
          border-bottom:
            1px solid #eee;
          color: #111;
          text-align: left;
          cursor: pointer;
          font-family: inherit;
        }


        .terrain-search-suggestion:last-child {
          border-bottom: 0;
        }


        .terrain-search-suggestion:hover,
        .terrain-search-suggestion.is-active {
          background: #f5f5f5;
        }


        .terrain-search-suggestion-name {
          display: block;
          font-size: 14px;
          font-weight: 600;
          line-height: 1.3;
          color: #111;
        }


        .terrain-search-suggestion-details {
          display: block;
          margin-top: 3px;
          font-size: 12px;
          line-height: 1.35;
          color: #6d6d6d;
        }


        .terrain-selection-help {
          display: none;
          margin-top: 12px;
          padding: 12px 14px;
          background: #f7f7f7;
          border:
            1px solid #e0e0e0;
          border-radius: 6px;
          font-size: 12px;
          line-height: 1.45;
          color: #666;
        }


        .terrain-selection-help.is-visible {
          display: block;
        }


        .terrain-selection-help strong {
          color: #111;
        }


        .terrain-selection-reset-rotation {
          margin-left: 8px;
          padding: 5px 9px;
          border:
            1px solid #cfcfcf;
          border-radius: 4px;
          background: #fff;
          color: #111;
          cursor: pointer;
          font: inherit;
          font-size: 11px;
        }


        .terrain-selection-handle-shell {
          background:
            transparent !important;
          border:
            0 !important;
        }


        .terrain-selection-corner-handle {
          width: 26px;
          height: 26px;
          display: flex;
          align-items: center;
          justify-content: center;
          box-sizing: border-box;
          border:
            2px solid #111;
          border-radius: 50%;
          background: #fff;
          color: #111;
          box-shadow:
            0 2px 7px
            rgba(
              0,
              0,
              0,
              0.28
            );
          font-size: 16px;
          font-weight: 800;
          line-height: 1;
          user-select: none;
        }


        .terrain-selection-corner-handle.corner-0,
        .terrain-selection-corner-handle.corner-2 {
          cursor: nwse-resize;
        }


        .terrain-selection-corner-handle.corner-1,
        .terrain-selection-corner-handle.corner-3 {
          cursor: nesw-resize;
        }


        .terrain-selection-resize-hint-shell {
          background: transparent !important;
          border: 0 !important;
          pointer-events: none !important;
        }


        .terrain-selection-resize-hint {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          white-space: nowrap;
          padding: 6px 9px;
          border-radius: 999px;
          background: rgba(255, 255, 255, 0.94);
          border: 1px solid rgba(17, 17, 17, 0.25);
          color: #111;
          box-shadow: 0 1px 5px rgba(0, 0, 0, 0.16);
          font-size: 11px;
          font-weight: 700;
          line-height: 1;
          transform: translate(-50%, -50%);
          pointer-events: none;
        }


        .terrain-select-button.terrain-manual-draw-option {
          background: #111 !important;
          color: #fff !important;
          border: 1px solid #111 !important;
          box-shadow: none !important;
          font-weight: 700 !important;
        }


        .terrain-select-button.terrain-manual-draw-option:hover {
          background: #2a2a2a !important;
          color: #fff !important;
        }


        .terrain-select-button.terrain-manual-draw-option.is-active {
          background: #fff !important;
          color: #111 !important;
          border: 2px solid #111 !important;
          box-shadow: 0 0 0 3px rgba(17, 17, 17, 0.08) !important;
          font-weight: 700 !important;
        }


        .terrain-select-button.terrain-manual-draw-option.is-active:hover {
          background: #f4f4f4 !important;
          color: #111 !important;
        }


        .terrain-selection-centre-handle,
        .terrain-selection-rotation-handle {
          width: 24px;
          height: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
          box-sizing: border-box;
          border:
            2px solid #111;
          border-radius: 50%;
          box-shadow:
            0 1px 5px
            rgba(
              0,
              0,
              0,
              0.25
            );
          font-size: 15px;
          font-weight: 700;
          line-height: 1;
          user-select: none;
        }


        .terrain-selection-centre-handle {
          background: #fff;
          color: #111;
          cursor: move;
        }


        .terrain-selection-rotation-handle {
          background: #111;
          color: #fff;
          cursor: grab;
        }


        .ridge-map-pin-controls { margin:14px 0 16px; padding:18px; border:1px solid #d8ded9; border-radius:12px; background:#fafbf9; color:#212b23; font-family:var(--font-body-family,inherit); }
        .ridge-map-pin-head { display:flex;align-items:flex-start;justify-content:space-between;gap:15px; }
        .ridge-map-pin-head strong { font-family:var(--font-heading-family,inherit); font-size:17px; font-weight:700; }
        .ridge-map-pin-head p { margin:6px 0 0;font-size:13px;color:#536053;line-height:1.5; }
        .ridge-map-change-pin { flex:none;border:1px solid #345043;background:#fff;color:#183525;border-radius:7px;padding:10px 13px;font:600 12px var(--font-body-family,inherit);cursor:pointer; }
        .ridge-map-change-pin:disabled { opacity:.5;cursor:not-allowed; }
        .ridge-map-pin-status { margin:14px 0;font-size:13px;line-height:1.5;font-weight:600;color:#3c5a43; }
        .ridge-pin-error .ridge-map-pin-status { color:#b43c28; }
        .ridge-marker-preview-warning { margin:12px 0; padding:13px 15px; border:1px solid #dfaaa3; border-radius:8px; background:#fff6f4; color:#923325; font-size:14px; line-height:1.5; }
        .ridge-marker-preview-warning[hidden] { display:none!important; }
        .terrain-preview-button:disabled { opacity:0.45!important; cursor:not-allowed!important; filter:grayscale(0.4); }
        .ridge-marker-recentre { margin-left:8px; background:#fff; color:#923325; border:1px solid #b65e50; border-radius:6px; padding:6px 10px; font:600 13px inherit; cursor:pointer; }

        .ridge-map-print-pin-label { display:flex;align-items:center;gap:12px;padding:13px;background:#fff;border:1px solid #e2e5e0;border-radius:8px;cursor:pointer; }
        .ridge-map-print-pin { width:19px;height:19px;accent-color:#28523c;flex:none; }
        .ridge-map-print-pin-label strong { display:block;color:#1e2c22;font-size:14px; }
        .ridge-map-print-pin-label small { display:block;color:#68746b;font-size:12px;line-height:1.5;margin-top:3px; }
        .ridge-map-location-shell { background:transparent!important;border:0!important; }
        .ridge-map-location-dot {display:block;width:18px;height:18px;margin:3px;background:#d53c2b;border:3px solid #fff;box-shadow:0 1px 6px #0009,0 0 0 2px #a32b1c;border-radius:50%;box-sizing:border-box;}
        .terrain-map.ridge-map-placing {cursor:crosshair;}
        .ridge-map-pin-controls button,.ridge-map-pin-controls input {font-family:var(--font-body-family,inherit);}
        .ridge-map-add-marker{margin:12px 0 6px;padding:11px 15px;border:1px solid #315941;border-radius:7px;background:#315941;color:#fff;font:700 13px var(--font-body-family,inherit);cursor:pointer;min-height:42px;}
        .ridge-map-add-marker:disabled{opacity:.45;cursor:not-allowed;}

.ridge-detail-colour-field{display:inline-flex;align-items:center;gap:7px;min-width:0;max-width:100%;color:#263d30;}
.ridge-detail-colour-swatch{display:inline-block;flex:none;width:17px;height:17px;border:1px solid #888;border-radius:50%;}
.ridge-detail-colour-select{box-sizing:border-box;max-width:100%;min-width:95px;min-height:40px;padding:7px 22px 7px 8px;border:1px solid #b5c4b7;border-radius:6px;background:#fff;color:#243b2c;font:inherit;font-size:16px;cursor:pointer;color-scheme:light;}
.ridge-detail-colour-select:focus-visible{outline:2px solid #3c6c4c;outline-offset:2px;}
.ridge-detail-colour-row{display:flex;justify-content:space-between;align-items:center;gap:10px;flex-wrap:wrap;margin-top:10px;font-size:13px;color:#263d30;}
.ridge-detail-colour-name{min-width:0;overflow-wrap:anywhere;flex:1 1 110px;}

        .ridge-map-marker-list{display:grid;gap:7px;margin:9px 0 10px;}
        .ridge-map-marker-item{display:flex;flex-wrap:wrap;gap:10px;align-items:center;justify-content:space-between;padding:9px 10px;border:1px solid #dce6db;border-radius:7px;background:#fff;}
        .ridge-map-marker-name{font-size:13px;font-weight:650;color:#263d30;}
        .ridge-map-marker-invalid{color:#ae392a!important;}
        .ridge-map-marker-actions{display:flex;gap:6px;flex-wrap:wrap;}
        .ridge-map-marker-actions button{padding:7px 10px;min-height:34px;border:1px solid #b9cbbd;border-radius:6px;background:#f9fcf8;color:#2c4834;font-size:12px;font-weight:650;cursor:pointer;}
        .ridge-map-location-dot{width:24px;height:24px;margin:2px;display:flex;align-items:center;justify-content:center;color:#fff;font-size:11px;font-weight:750;border-width:2px;}
        .ridge-map-gpx-controls {margin:14px 0 18px;padding:18px;border:1px solid #d8ded9;border-radius:12px;background:#fafbf9;font-family:var(--font-body-family,inherit);}
        .ridge-map-gpx-controls strong {font:700 16px var(--font-heading-family,inherit);color:#233528;}
        .ridge-map-gpx-controls p {color:#657166;font-size:13px;line-height:1.5;margin:6px 0 12px;}
        .ridge-map-gpx-row{display:flex;align-items:center;gap:10px;flex-wrap:wrap;}
        /* Use a full-size transparent native file input for reliable mobile taps.
           iOS can ignore a visually clipped 1px file input in a label. */
        .ridge-map-gpx-upload{position:relative;display:inline-flex;align-items:center;justify-content:center;box-sizing:border-box;min-height:44px;overflow:hidden;background:#263d30;color:white;border-radius:7px;padding:11px 16px;font:600 13px var(--font-body-family,inherit);cursor:pointer;touch-action:manipulation;}
        .ridge-map-gpx-upload input{position:absolute;inset:0;display:block;width:100%;height:100%;margin:0;padding:0;opacity:0;cursor:pointer;z-index:1;clip-path:none;overflow:visible;font-size:16px;}
        .ridge-map-gpx-upload:focus-within{outline:2px solid #365b47;outline-offset:3px;}
        .ridge-map-gpx-remove{padding:10px 14px;background:white;border:1px solid #bfc9c1;border-radius:7px;font:600 13px var(--font-body-family,inherit);cursor:pointer;}
        .ridge-map-gpx-remove[hidden]{display:none!important;}
        .ridge-map-gpx-file-list{display:grid;gap:7px;margin-top:12px;}
        .ridge-map-gpx-file-item{display:flex;flex-wrap:wrap;justify-content:space-between;align-items:center;gap:10px;padding:9px 11px;background:white;border:1px solid #e2e7e2;border-radius:7px;}
        .ridge-map-gpx-file-name{font-size:12px;line-height:1.45;min-width:0;overflow-wrap:anywhere;color:#263d30;}
        .ridge-map-gpx-file-delete{flex:none;background:#fff;border:1px solid #c8d3c8;border-radius:6px;padding:6px 10px;color:#344b3b;font:600 12px var(--font-body-family,inherit);cursor:pointer;}
        .ridge-map-gpx-state{margin:10px 0 0!important;color:#365641!important;overflow-wrap:anywhere;}
        .ridge-map-gpx-controls button,.ridge-map-gpx-controls input{font-family:var(--font-body-family,inherit);}
        .terrain-map { background:#f2f4f1; }
        .ridge-gpx-map-loading{position:absolute;left:50%;top:14px;transform:translateX(-50%);z-index:1300;pointer-events:none;
          display:flex;align-items:center;gap:9px;max-width:calc(100% - 30px);padding:10px 15px;border-radius:30px;
          background:#fff;color:#223b2b;border:1px solid #d4ded5;box-shadow:0 3px 16px #0002;
          font:600 12px var(--font-body-family,inherit);white-space:nowrap;}
        .ridge-gpx-map-loading[hidden]{display:none!important;}
        .ridge-gpx-map-spinner{width:15px;height:15px;flex:none;border:2px solid #d5e2da;
          border-top-color:#2e6044;border-radius:50%;animation:ridge-gpx-spin .8s linear infinite;}
        @keyframes ridge-gpx-spin{to{transform:rotate(360deg);}}
        @media (prefers-reduced-motion:reduce){.ridge-gpx-map-spinner{animation:none;}}
        @media screen
        and (max-width: 749px) {

          .terrain-orientation-buttons {
            flex-direction: column;
          }


          .terrain-search-suggestion {
            padding: 12px 13px;
          }

        }

      `;


      document.head.appendChild(
        style
      );
    }


    addStyles();


    /*
     * Automatic starter box is the default, but manual drawing
     * remains available as a clear secondary option.
     */
    if (selectButton) {
      selectButton.style.display =
        "";

      selectButton.classList.add(
        "terrain-manual-draw-option"
      );

      selectButton.textContent =
        "Draw area";

      selectButton.setAttribute(
        "aria-pressed",
        "false"
      );
    }

    const mapInstructions =
      mapStep
        ? mapStep.querySelector(
            ".terrain-section-title span"
          )
        : null;

    if (mapInstructions) {
      mapInstructions.textContent =
        "Search for a place and the terrain box will appear. Resize, rotate or redraw it. Optionally add a NZ$5 location marker or a NZ$10 GPX trail before generating your preview.";
    }


    // ==============================================================
    // OPTIONAL PRINTED MARKERS (0–10) — independent, like the GPX list
    // ==============================================================
    pointControls = document.createElement('div');
    pointControls.className = 'ridge-map-pin-controls';
    pointControls.innerHTML = `
      <div class="ridge-map-pin-head">
        <div>
          <strong>Optional location markers · +NZ$5 total</strong>
          <p>Add up to 10 raised markers. Drag, centre or delete each one independently. Markers stay in place when you move, resize or rotate the terrain box.</p>
        </div>
      </div>
      <button type="button" class="ridge-map-add-marker">+ Add marker <span class="ridge-marker-count">(0/10)</span></button>
      <div class="ridge-map-marker-list" aria-label="Your terrain markers"></div>
      <div class="ridge-map-pin-status" role="status" aria-live="polite">No markers selected · NZ$0</div>`;
    const pointAnchor = wrapper.querySelector('.terrain-map-guide');
    if (pointAnchor) pointAnchor.after(pointControls);
    else mapElement.before(pointControls);
    pointMessage = pointControls.querySelector('.ridge-map-pin-status');
    markerList = pointControls.querySelector('.ridge-map-marker-list');
    addMarkerButton = pointControls.querySelector('.ridge-map-add-marker');
    addMarkerButton.addEventListener('click', () => {
      if (!selectedSize || terrainMarkers.length >= MAX_TERRAIN_MARKERS) return;
      const positions = [
        [.5,.5],[.38,.4],[.62,.4],[.38,.6],[.62,.6],
        [.5,.3],[.5,.7],[.3,.5],[.7,.5],[.5,.82]
      ];
      // Reuse an empty slot after an individual deletion, rather than
      // stacking the replacement marker on top of an existing one.
      const free = positions.find(([u,v]) => terrainMarkers.every(entry => {
        const uv=getPointUV(entry);
        return !uv || Math.hypot(uv.u-u,uv.v-v)>.09;
      }));
      const [u,v] = free || positions[terrainMarkers.length];
      const start = getPointAtUV(u,v) || map.getCenter();
      // The marker's initial location is calculated from the current box;
      // from this point onward it is an independent geographic location.
      addTerrainMarker(start);
      if (selectionCorners) updateInformation();
      updatePointControls();
      saveState();
    });
    markerList.addEventListener('click', event => {
      const button = event.target.closest('button[data-marker-action]');
      if (!button) return;
      const entry = terrainMarkers.find(item => item.id === Number(button.dataset.markerId));
      if (!entry) return;
      if (button.dataset.markerAction === 'delete') {
        map.removeLayer(entry.layer);
        terrainMarkers = terrainMarkers.filter(item => item !== entry);
      } else if (button.dataset.markerAction === 'centre') {
        centreTerrainMarker(entry);
      }
      if (selectionCorners) updateInformation();
      updatePointControls();
      saveState();
    });

    // Keep map selections in sync with colour edits made on Customize.
    wrapper.addEventListener('ridge-detail-colours-changed',event => {
      const terrain=event.detail;
      if(!terrain) return;
      terrainMarkers.forEach((entry,index) => {
        if(terrain.markers && terrain.markers[index]) entry.colour=detailColour(terrain.markers[index].colour);
      });
      mapGpxFiles.forEach(file => {
        const route=(terrain.gpxRoutes || []).find(route => route.id===file.id);
        if(route) file.colour=detailColour(route.colour);
      });
      updatePointControls(); updateGpxOverlay(); saveState();
    });

    function getSelectionCentre() {
      return getPointAtUV(.5,.5);
    }
    function getPointAtUV(u,v) {
      if (!selectionCorners || selectionCorners.length !== 4) return null;
      const a=map.latLngToLayerPoint(selectionCorners[0]);
      const b=map.latLngToLayerPoint(selectionCorners[1]);
      const d=map.latLngToLayerPoint(selectionCorners[3]);
      return map.layerPointToLatLng(L.point(
        a.x+u*(b.x-a.x)+v*(d.x-a.x),
        a.y+u*(b.y-a.y)+v*(d.y-a.y)
      ));
    }
    function centreTerrainMarker(entry) {
      // A one-time move, not an instruction to track the centre afterwards.
      const centre = getSelectionCentre() || map.getCenter();
      entry.point=L.latLng(centre);
      entry.layer.setLatLng(entry.point);
    }
    function markerLeafletIcon(number, colour) {
      const key=detailColour(colour);
      const ink=['white','beige','gold'].includes(key)?'#202020':'#ffffff';
      return L.divIcon({
        className:'ridge-map-location-shell',
        html:'<span class="ridge-map-location-dot" style="background:'+DETAIL_COLOURS[key].hex+';color:'+ink+'" aria-label="Marker '+number+'">'+number+'</span>',
        iconSize:[28,28],iconAnchor:[14,14]
      });
    }
    function updateMarkerNumbers() {
      terrainMarkers.forEach((entry,index) => entry.layer.setIcon(markerLeafletIcon(index+1,entry.colour)));
    }
    function addTerrainMarker(latlng, colour) {
      if (terrainMarkers.length >= MAX_TERRAIN_MARKERS) return null;
      const entry = {
        id:nextTerrainMarkerId++,
        colour:detailColour(colour),
        point:L.latLng(latlng),
        layer:null
      };
      entry.layer=L.marker(entry.point,{
        icon:markerLeafletIcon(terrainMarkers.length+1,entry.colour),
        draggable:true,keyboard:true,zIndexOffset:1500
      }).addTo(map);
      entry.layer.on('dragend',() => {
        entry.point=entry.layer.getLatLng();
        if (selectionCorners) updateInformation();
        updatePointControls();
        saveState();
      });
      terrainMarkers.push(entry);
      updateMarkerNumbers();
      updatePointControls();
      return entry;
    }
    // ==============================================================
    // GPX MAP OVERLAY — upload before the lightweight preview
    // ==============================================================
    const gpxPanel=document.createElement('div');
    gpxPanel.className='ridge-map-gpx-controls';
    gpxPanel.innerHTML=`
      <strong>Optional GPX trail · +NZ$10</strong>
      <p>Add up to 5 GPX routes to one print. All routes will be shown together; the GPX add-on is NZ$10 total. Move, resize or rotate the terrain box to cover them.</p>
      <div class="ridge-map-gpx-row">
        <label class="ridge-map-gpx-upload"><span class="ridge-map-gpx-upload-text">Add GPX files</span><input class="ridge-map-gpx-file" type="file" multiple aria-label="Add GPX route files"></label>
        <button type="button" class="ridge-map-gpx-remove" hidden>Remove all</button>
      </div>
      <div class="ridge-map-gpx-file-list" aria-label="Selected GPX routes"></div>
      <p class="ridge-map-gpx-state" role="status" aria-live="polite">No GPX trail selected · NZ$0</p>`;
    pointControls.after(gpxPanel);
    gpxUploadControl=gpxPanel.querySelector('.ridge-map-gpx-file');
    gpxStatus=gpxPanel.querySelector('.ridge-map-gpx-state');
    gpxRemove=gpxPanel.querySelector('.ridge-map-gpx-remove');
    gpxFileList=gpxPanel.querySelector('.ridge-map-gpx-file-list');
    // Mobile Files apps do not reliably advertise a GPX MIME type, so the
    // chooser is unfiltered; the handler validates the .gpx extension below.
    // iOS Safari is more reliable selecting one file per tap. Existing routes
    // remain loaded, and the normal five-file maximum still applies.
    const isIOSFilePicker = /iPad|iPhone|iPod/i.test(navigator.userAgent || '') ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    if (isIOSFilePicker) {
      gpxUploadControl.multiple = false;
      gpxPanel.querySelector('.ridge-map-gpx-upload-text').textContent = 'Add GPX file';
    }

    // Keep the rest of the map interactive and visible during a large GPX upload.
    const gpxLoadingBadge = document.createElement('div');
    gpxLoadingBadge.className = 'ridge-gpx-map-loading';
    gpxLoadingBadge.setAttribute('role', 'status');
    gpxLoadingBadge.setAttribute('aria-live', 'polite');
    gpxLoadingBadge.hidden = true;
    gpxLoadingBadge.innerHTML = '<span class="ridge-gpx-map-spinner" aria-hidden="true"></span><span class="ridge-gpx-map-loading-text"></span>';
    mapElement.appendChild(gpxLoadingBadge);
    const gpxLoadingText = gpxLoadingBadge.querySelector('.ridge-gpx-map-loading-text');

    function showGpxLoading(message) {
      gpxLoadingText.textContent = message;
      gpxLoadingBadge.hidden = false;
    }

    function clearGpxTileWait() {
      if (gpxTileLoadHandler) {
        Object.values(mapSkins).forEach(layer => layer.off('load', gpxTileLoadHandler));
        gpxTileLoadHandler = null;
      }
      if (gpxTileLoadTimer !== null) {
        clearTimeout(gpxTileLoadTimer);
        gpxTileLoadTimer = null;
      }
    }

    function endGpxLoading(version) {
      if (version !== gpxLoadVersion) return;
      clearGpxTileWait();
      gpxLoadingBadge.hidden = true;
    }

    function updateGpxOverlay() {
      if (mapGpxLine) { map.removeLayer(mapGpxLine); mapGpxLine = null; }
      gpxFileList.replaceChildren();
      mapGpxFiles.forEach((file, index) => {
        const item = document.createElement('div');
        item.className = 'ridge-map-gpx-file-item';
        const name = document.createElement('span');
        name.className = 'ridge-map-gpx-file-name';
        name.textContent = (index + 1) + '. ' + file.name;
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'ridge-map-gpx-file-delete';
        remove.textContent = 'Remove';
        remove.setAttribute('aria-label', 'Remove GPX ' + file.name);
        remove.addEventListener('click', () => {
          ++gpxLoadVersion; // Cancel any pending additions.
          clearGpxTileWait();
          gpxLoadingBadge.hidden = true;
          mapGpxFiles = mapGpxFiles.filter((_, i) => i !== index);
          mapGpx = combineSelectedGpx(mapGpxFiles);
          updateGpxOverlay();
          if (selectionCorners) updateInformation();
          saveState();
        });
        const colourField=detailColourSelect(file.colour,'Colour for GPX '+file.name,value => {
          file.colour=value;
          updateGpxOverlay();
          if(selectionCorners) updateInformation();
          saveState();
        });
        item.append(name, colourField, remove);
        gpxFileList.appendChild(item);
      });
      if (mapGpx) {
        mapGpxLine = L.featureGroup(mapGpxFiles.map(file => L.polyline(file.displaySegments, {
          color:DETAIL_COLOURS[detailColour(file.colour)].hex, weight:4, opacity:.95,
          interactive:false, renderer:mapGpxRenderer, smoothFactor:1.5
        }))).addTo(map);
        mapGpxLine.bringToFront();
        gpxRemove.hidden = false;
        const n = mapGpxFiles.length;
        gpxStatus.textContent = n + (n === 1 ? ' GPX route' : ' GPX routes') +
          ' selected · +NZ$10 total if included in preview';
      } else {
        gpxRemove.hidden = true;
        gpxStatus.textContent = 'No GPX trail selected · NZ$0';
      }
    }

    // The API still receives exactly ONE GPX. Each input file is represented as
    // its own <trk> and each original segment remains its own <trkseg>, so
    // different routes are never accidentally connected by a straight line.
    // Canonical XML order matches route metadata, including for a single file.
    function combineSelectedGpx(files) {
      if (!files.length) return null;
      const segments = files.flatMap(file => file.fullSegments);
      const points = segments.reduce((count, part) => count + part.length, 0);
      if (segments.length > MAX_GPX_SEGMENTS)
        throw new Error('The combined GPX routes exceed 60 track segments. Please use fewer routes.');
      if (points > MAX_GPX_POINTS)
        throw new Error('The combined GPX routes exceed 20,000 track points. Please simplify the routes first.');
      const escapeXml = value => value.replace(/&/g, '&amp;').replace(/</g, '&lt;')
        .replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&apos;');
      const parts = ['<?xml version="1.0" encoding="UTF-8"?>',
        '<gpx version="1.1" creator="Ridge Studios" xmlns="http://www.topografix.com/GPX/1/1">'];
      for (const file of files) {
        parts.push('<trk><name>', escapeXml(file.name), '</name>');
        for (const segment of file.fullSegments) {
          parts.push('<trkseg>');
          for (const point of segment) {
            parts.push('<trkpt lat="', String(point[0]), '" lon="', String(point[1]), '"></trkpt>');
          }
          parts.push('</trkseg>');
        }
        parts.push('</trk>');
      }
      parts.push('</gpx>');
      const xml = parts.join('');
      if (new Blob([xml]).size > MAX_GPX_BYTES)
        throw new Error('The combined GPX is over 10 MB. Please use smaller routes.');
      return {
        xml,
        name:files.length === 1 ? files[0].name : files.length + ' GPX routes',
        displaySegments:simplifyGpxForMap(segments)
      };
    }

    // Douglas-Peucker simplification, only for the 2D map display.
    // The original XML is NEVER simplified, so the printed GPX/STL remains exact.
    function simplifyGpxSegment(points, toleranceMetres) {
      const n = points.length;
      if (n <= 2) return points;
      const meanLatitude = (points[0][0] + points[n - 1][0]) * Math.PI / 360;
      const xScale = 111320 * Math.max(0.001, Math.cos(meanLatitude));
      const yScale = 111320;
      const projected = points.map(p => [p[1] * xScale, p[0] * yScale]);
      const keep = new Uint8Array(n);
      keep[0] = 1; keep[n - 1] = 1;
      const stack = [[0, n - 1]];
      const toleranceSquared = toleranceMetres * toleranceMetres;
      while (stack.length) {
        const range = stack.pop();
        const first = range[0], last = range[1];
        const a = projected[first], b = projected[last];
        const dx = b[0] - a[0], dy = b[1] - a[1];
        const lengthSquared = dx * dx + dy * dy;
        let farthest = -1, maximum = 0;
        for (let i = first + 1; i < last; i++) {
          const p = projected[i];
          const t = lengthSquared > 0
            ? Math.max(0, Math.min(1, ((p[0] - a[0]) * dx + (p[1] - a[1]) * dy) / lengthSquared))
            : 0;
          const ex = p[0] - a[0] - t * dx;
          const ey = p[1] - a[1] - t * dy;
          const distanceSquared = ex * ex + ey * ey;
          if (distanceSquared > maximum) {
            maximum = distanceSquared;
            farthest = i;
          }
        }
        if (farthest !== -1 && maximum > toleranceSquared) {
          keep[farthest] = 1;
          stack.push([first, farthest], [farthest, last]);
        }
      }
      return points.filter((_, index) => keep[index]);
    }

    function simplifyGpxForMap(segments) {
      const maxDisplayPoints = 2600;
      let tolerance = 3;
      let simplified = segments;
      let count = segments.reduce((sum, s) => sum + s.length, 0);
      // Apply the same tolerance to all segments; always preserve endpoints.
      for (let pass = 0; count > maxDisplayPoints && pass < 17; pass++) {
        simplified = segments.map(segment => simplifyGpxSegment(segment, tolerance));
        count = simplified.reduce((sum, s) => sum + s.length, 0);
        tolerance *= 1.8;
      }
      // Guaranteed upper bound for unusual, highly noisy GPX files.
      if (count > maxDisplayPoints) {
        const extra = maxDisplayPoints - 2 * simplified.length;
        const interiors = simplified.reduce((sum, s) => sum + Math.max(0, s.length - 2), 0);
        let remaining = Math.max(0, extra);
        simplified = simplified.map((segment, index) => {
          if (segment.length <= 2) return segment;
          const available = segment.length - 2;
          const slots = index === simplified.length - 1
            ? Math.min(available, remaining)
            : Math.min(available, Math.floor((available / interiors) * Math.max(0, extra)));
          remaining -= slots;
          const output = [segment[0]];
          for (let i = 1; i <= slots; i++) {
            output.push(segment[1 + Math.floor(i * available / (slots + 1))]);
          }
          output.push(segment[segment.length - 1]);
          return output;
        });
      }
      return simplified;
    }

    function parseGpxMap(xml) {
      if (/<!DOCTYPE|<!ENTITY/i.test(xml)) throw new Error('GPX files with DTD or entities are not allowed.');
      const doc = new DOMParser().parseFromString(xml, 'application/xml');
      if (doc.getElementsByTagName('parsererror').length || !doc.documentElement || doc.documentElement.localName.toLowerCase() !== 'gpx')
        throw new Error('Choose a valid GPX track or route file.');
      const segments = []; let pointsCount = 0;
      const containers = Array.from(doc.getElementsByTagName('*')).filter(n => ['trkseg','rte'].includes(n.localName.toLowerCase()));
      containers.forEach(group => {
        const points = [];
        Array.from(group.children).forEach(node => {
          if (!['trkpt','rtept'].includes(node.localName.toLowerCase())) return;
          if (!node.hasAttribute('lat') || !node.hasAttribute('lon')) return;
          const lat = Number(node.getAttribute('lat')), lng = Number(node.getAttribute('lon'));
          if (!Number.isFinite(lat) || !Number.isFinite(lng) || Math.abs(lat) > 90 || Math.abs(lng) > 180) return;
          pointsCount++;
          if (pointsCount > 20000) throw new Error('GPX must contain at most 20,000 track points.');
          points.push([lat, lng]);
        });
        if (points.length >= 2) segments.push(points);
      });
      if (!segments.length) throw new Error('No GPX track or route found in the file.');
      if (segments.length > 60) throw new Error('GPX has too many disconnected track segments.');
      return segments;
    }

    // Parse and simplify GPX off the UI thread. A large GPX should not freeze
    // the entire Shopify page while the XML is being scanned.
    // This parser reads only GPX trkseg/rte point coordinates; the original
    // unmodified XML still goes to the server for the actual printed model.
    function parseGpxInWorker(xml) {
      if (/<!DOCTYPE|<!ENTITY/i.test(xml)) {
        throw new Error('GPX files with DTD or entities are not allowed.');
      }
      const segments = [];
      const stack = [];
      let current = null;
      let rootSeen = false;
      let rootClosed = false;
      let pointsCount = 0;
      let position = 0;

      const localName = name => name.slice(name.lastIndexOf(':') + 1).toLowerCase();
      const namePattern = /^([A-Za-z_][A-Za-z0-9_.:-]*)/;
      const attributePattern = /\s(lat|lon)\s*=\s*(["'])(.*?)\2/g;

      while (true) {
        const opening = xml.indexOf('<', position);
        if (opening === -1) break;
        if (xml.startsWith('<!--', opening)) {
          const close = xml.indexOf('-->', opening + 4);
          if (close === -1) throw new Error('Invalid GPX XML comment.');
          position = close + 3;
          continue;
        }
        if (xml.startsWith('<![CDATA[', opening)) {
          const close = xml.indexOf(']]>', opening + 9);
          if (close === -1) throw new Error('Invalid GPX CDATA section.');
          position = close + 3;
          continue;
        }
        if (xml.startsWith('<?', opening)) {
          const close = xml.indexOf('?>', opening + 2);
          if (close === -1) throw new Error('Invalid GPX processing instruction.');
          position = close + 2;
          continue;
        }
        if (xml.startsWith('<!', opening)) throw new Error('Unsupported GPX XML declaration.');
        let closing = opening + 1;
        let quote = '';
        for (; closing < xml.length; closing++) {
          const char = xml[closing];
          if (quote) {
            if (char === quote) quote = '';
          } else if (char === '"' || char === "'") {
            quote = char;
          } else if (char === '>') {
            break;
          }
        }
        if (closing >= xml.length) throw new Error('GPX contains an unclosed XML tag.');
        let tag = xml.slice(opening + 1, closing).trim();
        position = closing + 1;

        if (tag.startsWith('/')) {
          const match = namePattern.exec(tag.slice(1));
          if (!match || tag.slice(1).trim() !== match[1] || !stack.length) {
            throw new Error('Invalid closing tag in GPX.');
          }
          const open = stack.pop();
          if (open !== match[1]) throw new Error('Mismatched GPX XML tags.');
          if (current && stack.length === current.depth - 1 && open === current.tag) {
            if (current.points.length >= 2) segments.push(current.points);
            current = null;
          }
          if (!stack.length) rootClosed = true;
          continue;
        }

        const nameMatch = namePattern.exec(tag);
        if (!nameMatch) throw new Error('Invalid XML tag in GPX file.');
        const tagName = nameMatch[1];
        const short = localName(tagName);
        const selfClosing = /\/\s*$/.test(tag);
        if (!rootSeen) {
          if (short !== 'gpx') throw new Error('Choose a valid GPX track or route file.');
          rootSeen = true;
        } else if (rootClosed) {
          throw new Error('GPX has multiple XML root elements.');
        }

        if (!current && (short === 'trkseg' || short === 'rte')) {
          // Match the old DOM parser: trkseg and rte each define one segment.
          current = { tag: tagName, depth: stack.length + 1, points: [] };
        } else if (current && stack.length === current.depth &&
            ((localName(current.tag) === 'trkseg' && short === 'trkpt') ||
             (localName(current.tag) === 'rte' && short === 'rtept'))) {
          let lat = null, lon = null;
          attributePattern.lastIndex = 0;
          const attributes = tag.slice(nameMatch[0].length);
          let match;
          while ((match = attributePattern.exec(attributes)) !== null) {
            if (match[1] === 'lat') lat = Number(match[3]);
            if (match[1] === 'lon') lon = Number(match[3]);
          }
          if (lat !== null && lon !== null && Number.isFinite(lat) && Number.isFinite(lon)
              && Math.abs(lat) <= 90 && Math.abs(lon) <= 180) {
            pointsCount++;
            if (pointsCount > 20000) throw new Error('GPX must contain at most 20,000 track points.');
            current.points.push([lat, lon]);
          }
        }

        if (!selfClosing) {
          stack.push(tagName);
        } else if (current && current.tag === tagName && stack.length === current.depth - 1) {
          // Empty trkseg/rte may be self-closing.
          current = null;
        } else if (short === 'gpx') {
          rootClosed = true;
        }
      }
      if (!rootSeen || !rootClosed || stack.length || !segments.length) {
        throw new Error('No valid GPX track or route found in the file.');
      }
      if (segments.length > 60) throw new Error('GPX has too many disconnected track segments.');
      return segments;
    }

    function createGpxWorker() {
      const workerCode = [
        parseGpxInWorker.toString(),
        simplifyGpxSegment.toString(),
        simplifyGpxForMap.toString(),
        'self.onmessage = function(event) {',
        '  try {',
        '    const full = parseGpxInWorker(event.data.xml);',
        '    const simplified = simplifyGpxForMap(full);',
        '    self.postMessage({ ok: true, displaySegments: simplified, fullSegments: full });',
        '  } catch (error) {',
        '    self.postMessage({ ok: false, error: error.message || "Invalid GPX file" });',
        '  }',
        '};'
      ].join('\n');
      const url = URL.createObjectURL(new Blob([workerCode], { type:'text/javascript' }));
      try {
        return new Worker(url);
      } finally {
        URL.revokeObjectURL(url);
      }
    }

    // File.text() can be missing or fail on older mobile browsers.
    async function readGpxText(file) {
      if (file && typeof file.text === 'function') {
        try { return await file.text(); }
        catch (error) { console.warn('GPX File.text failed; trying FileReader:', error); }
      }
      return new Promise((resolve, reject) => {
        if (typeof FileReader === 'undefined') {
          reject(new Error('This browser cannot read GPX files.'));
          return;
        }
        const reader = new FileReader();
        reader.onload = () => resolve(String(reader.result || ''));
        reader.onerror = () => reject(reader.error || new Error('Could not read the GPX file.'));
        reader.onabort = () => reject(new Error('Reading the GPX file was cancelled.'));
        reader.readAsText(file, 'UTF-8');
      });
    }

    async function prepareGpxDisplay(xml) {
      let worker;
      try {
        worker = createGpxWorker();
      } catch (error) {
        // Some storefront CSPs block Blob workers; retain functional fallback.
        console.warn('GPX background worker unavailable:', error);
        const fullSegments = parseGpxMap(xml);
        return { displaySegments: simplifyGpxForMap(fullSegments), fullSegments };
      }
      try {
        return await new Promise((resolve, reject) => {
          const timer = setTimeout(() => reject(new Error('GPX processing took too long.')), 30000);
          worker.onmessage = event => {
            clearTimeout(timer);
            const result = event.data;
            if (result && result.ok) resolve({
              displaySegments: result.displaySegments,
              fullSegments: result.fullSegments
            });
            else reject(new Error((result && result.error) || 'Invalid GPX file.'));
          };
          worker.onerror = event => {
            clearTimeout(timer);
            reject(new Error('GPX background processing failed.'));
          };
          worker.postMessage({ xml });
        });
      } catch (error) {
        // Some mobile browsers / storefront CSPs allow Worker construction but
        // fail to load Blob workers. Keep uploading possible in that case.
        // The DOM parser also gives genuinely invalid GPX a useful error.
        console.warn('GPX background parsing unavailable; using main-thread parser:', error);
        const fullSegments = parseGpxMap(xml);
        return { displaySegments: simplifyGpxForMap(fullSegments), fullSegments };
      } finally {
        worker.terminate();
      }
    }

    gpxUploadControl.addEventListener('change', async function() {
      const chosen = Array.from(gpxUploadControl.files || []);
      // Clearing the input allows a route to be selected again after removal.
      gpxUploadControl.value = '';
      if (!chosen.length) return;
      const version = ++gpxLoadVersion;
      clearGpxTileWait();
      gpxLoadingBadge.hidden = true;
      if (chosen.length + mapGpxFiles.length > MAX_GPX_FILES) {
        gpxStatus.textContent = 'You can add up to ' + MAX_GPX_FILES + ' GPX files per print.';
        return;
      }
      if (chosen.some(file => !/\.gpx$/i.test(file.name))) {
        gpxStatus.textContent = 'Please choose only .gpx files.';
        return;
      }
      if (chosen.some(file => file.size > MAX_GPX_BYTES)) {
        gpxStatus.textContent = 'Each GPX must be under 10 MB.';
        return;
      }
      const existingBytes = mapGpxFiles.reduce((sum, file) => sum + file.bytes, 0);
      if (existingBytes + chosen.reduce((sum, file) => sum + file.size, 0) > MAX_GPX_BYTES) {
        gpxStatus.textContent = 'Your GPX files must be under 10 MB combined.';
        return;
      }
      const oldKeys = new Set(mapGpxFiles.map(file => file.key));
      const newKeys = chosen.map(file => file.name + '/' + file.size + '/' + file.lastModified);
      if (newKeys.some(key => oldKeys.has(key)) || new Set(newKeys).size !== newKeys.length) {
        gpxStatus.textContent = 'That GPX file is already on the map.';
        return;
      }
      showGpxLoading('Loading GPX routes…');
      gpxStatus.textContent = 'Reading ' + chosen.length + (chosen.length === 1 ? ' GPX file…' : ' GPX files…');
      // Give the browser time to paint the loading indicator before processing.
      await new Promise(resolve => requestAnimationFrame(() => setTimeout(resolve, 0)));
      if (version !== gpxLoadVersion) return;
      try {
        const nextFiles = [...mapGpxFiles];
        for (const file of chosen) {
          const xml = await readGpxText(file);
          if (version !== gpxLoadVersion) return;
          showGpxLoading('Processing ' + file.name + '…');
          const prepared = await prepareGpxDisplay(xml);
          if (version !== gpxLoadVersion) return;
          nextFiles.push({
            id:'route_'+nextGpxRouteId++,
            colour:'red',
            key:file.name + '/' + file.size + '/' + file.lastModified,
            name:file.name.slice(0, 90),
            bytes:file.size,
            xml,
            fullSegments:prepared.fullSegments,
            displaySegments:prepared.displaySegments
          });
        }
        const merged = combineSelectedGpx(nextFiles); // Validate limits before changing the map.
        if (version !== gpxLoadVersion) return;
        mapGpxFiles = nextFiles;
        mapGpx = merged;
        updateGpxOverlay();
        const bounds = mapGpxLine.getBounds();
        if (bounds.isValid()) {
          showGpxLoading('Loading map background…');
          map.fitBounds(bounds.pad(.2), { maxZoom:13, animate:false });
          lastSearchLatLng = bounds.getCenter();
          if (selectedSize) createStarterSelection(lastSearchLatLng, false);
          if (typeof mapSkins[currentSkin].isLoading === 'function' && !mapSkins[currentSkin].isLoading()) {
            endGpxLoading(version);
          } else {
            gpxTileLoadHandler = () => endGpxLoading(version);
            mapSkins[currentSkin].on('load', gpxTileLoadHandler);
            gpxTileLoadTimer = setTimeout(() => endGpxLoading(version), 6500);
          }
        } else {
          endGpxLoading(version);
        }
        if (selectionCorners) updateInformation();
        saveState();
      } catch (err) {
        endGpxLoading(version);
        gpxStatus.textContent = 'Could not add GPX: ' + (err.message || 'Invalid file');
      }
    });

    gpxRemove.addEventListener('click', function() {
      ++gpxLoadVersion; // Cancel an in-progress upload before it can redraw.
      clearGpxTileWait();
      gpxLoadingBadge.hidden = true;
      mapGpxFiles = [];
      mapGpx = null;
      gpxUploadControl.value = '';
      updateGpxOverlay();
      if (selectionCorners) updateInformation();
      saveState();
    });

    function getPointUV(entry) {
      if (!entry || !entry.point || !selectionCorners || selectionCorners.length !== 4) return null;
      const a = map.latLngToLayerPoint(selectionCorners[0]);
      const b = map.latLngToLayerPoint(selectionCorners[1]);
      const d = map.latLngToLayerPoint(selectionCorners[3]);
      const point = map.latLngToLayerPoint(entry.point);
      const ex = {x:b.x-a.x,y:b.y-a.y}, ey={x:d.x-a.x,y:d.y-a.y};
      const dx=point.x-a.x,dy=point.y-a.y;
      const determinant=ex.x*ey.y-ex.y*ey.x;
      if (Math.abs(determinant)<.000001) return null;
      const u=(dx*ey.y-dy*ey.x)/determinant;
      const v=(ex.x*dy-ey.x*dx)/determinant;
      return Number.isFinite(u) && Number.isFinite(v) ? {u,v} : null;
    }
    function pinWithinSelection(entry) {
      const uv=getPointUV(entry);
      // Same 2.5% printable inset used by the paid STL generator.
      return !!(uv && uv.u>=.025 && uv.u<=.975 && uv.v>=.025 && uv.v<=.975);
    }
    function allMarkersValid() {
      return terrainMarkers.every(pinWithinSelection);
    }
    function updatePointControls() {
      if (!pointControls) return;
      const invalid=!!selectionCorners && !allMarkersValid();
      addMarkerButton.disabled=!selectedSize || terrainMarkers.length>=MAX_TERRAIN_MARKERS;
      pointControls.querySelector('.ridge-marker-count').textContent=
        '('+terrainMarkers.length+'/'+MAX_TERRAIN_MARKERS+')';
      markerList.replaceChildren();
      terrainMarkers.forEach((entry,index) => {
        const item=document.createElement('div');
        item.className='ridge-map-marker-item';
        const label=document.createElement('span');
        label.className='ridge-map-marker-name';
        const valid=!selectionCorners || pinWithinSelection(entry);
        label.textContent='Marker '+(index+1)+(valid?'':' · Outside terrain');
        if (!valid) label.classList.add('ridge-map-marker-invalid');
        const actions=document.createElement('div');
        actions.className='ridge-map-marker-actions';
        for (const [action,text] of [['centre','Centre'],['delete','Delete']]) {
          const button=document.createElement('button');
          button.type='button';
          button.dataset.markerAction=action;
          button.dataset.markerId=String(entry.id);
          button.textContent=text;
          button.setAttribute('aria-label',text+' marker '+(index+1));
          actions.appendChild(button);
        }
        const colourField=detailColourSelect(entry.colour,'Colour for marker '+(index+1),value => {
          entry.colour=value;
          updateMarkerNumbers();
          if(selectionCorners) updateInformation();
          saveState();
        });
        item.append(label,colourField,actions);
        markerList.appendChild(item);
      });
      updateMarkerNumbers();
      if (!selectedSize) pointMessage.textContent='Choose a terrain size to add markers.';
      else if (!terrainMarkers.length) pointMessage.textContent='No markers selected · NZ$0';
      else if (!selectionCorners) pointMessage.textContent=terrainMarkers.length+' marker(s) added. Select a terrain area.';
      else if (invalid) pointMessage.textContent='One or more markers are outside the terrain. Move or centre them before generating.';
      else pointMessage.textContent=terrainMarkers.length+' '+(terrainMarkers.length===1?'marker':'markers')+' selected · +NZ$5 total';
      pointControls.classList.toggle('ridge-pin-error',invalid);
      mapElement.classList.remove('ridge-map-placing');
      if (selectButton) selectButton.disabled=!selectedSize;
      markerPreviewWarning.hidden=!invalid;
      if (previewButton) previewButton.disabled=!selectedSize || invalid;
    }
    updatePointControls();

    function createOrientationControls() {

      let controls =
        sizeSelection.querySelector(
          ".terrain-orientation-controls"
        );


      if (
        controls
      ) {
        return controls;
      }


      controls =
        document.createElement(
          "div"
        );


      controls.className =
        "terrain-orientation-controls";


      controls.style.display =
        "none";


      controls.innerHTML = `

        <span class="terrain-orientation-title">
          Model orientation
        </span>

        <div class="terrain-orientation-buttons">

          <button
            type="button"
            class="terrain-orientation-button"
            data-orientation="landscape"
          >
            Landscape
          </button>

          <button
            type="button"
            class="terrain-orientation-button"
            data-orientation="portrait"
          >
            Portrait
          </button>

        </div>

      `;


      if (
        sizeSummary
        &&
        sizeSummary.nextSibling
      ) {

        sizeSummary.parentNode.insertBefore(
          controls,
          sizeSummary.nextSibling
        );

      } else {

        sizeSelection.appendChild(
          controls
        );

      }


      controls
        .querySelectorAll(
          ".terrain-orientation-button"
        )
        .forEach(
          function (
            button
          ) {

            button.addEventListener(
              "click",
              function () {

                setOrientation(
                  button.dataset.orientation
                );

              }
            );

          }
        );


      return controls;
    }


    const orientationControls =
      createOrientationControls();


    function createHeightControls() {

      let controls =
        wrapper.querySelector(
          ".terrain-height-controls"
        );


      if (
        controls
      ) {
        return controls;
      }


      controls =
        document.createElement(
          "div"
        );


      controls.className =
        "terrain-height-controls";


      controls.style.display =
        "none";


      controls.innerHTML = `

        <div class="terrain-height-header">

          <span class="terrain-height-title">
            Terrain height boost
          </span>

          <span class="terrain-height-value">
            1.5×
          </span>

        </div>


        <input
          type="range"
          class="terrain-height-slider"
          min="1"
          max="4"
          step="0.5"
          value="1.5"
          aria-label="Terrain height boost"
        >


        <div class="terrain-height-labels">
          <span>1× · No boost</span>
          <span>2×</span>
          <span>3×</span>
          <span>4× · Maximum</span>
        </div>


        <p class="terrain-height-description">
          Makes hills and mountains taller without changing the area you selected. 1× means no boost; 2× doubles the terrain height. Adjust before generating your preview.
        </p>

      `;


      /*
       * Keep the terrain height control beside the preview
       * instead of up beside the size cards.
       */
      if (
        selectedBox
        &&
        previewButton
      ) {

        selectedBox.insertBefore(
          controls,
          previewButton
        );

      } else {

        sizeSelection.appendChild(
          controls
        );

      }


      controls
        .querySelector(
          ".terrain-height-slider"
        )
        .addEventListener(
          "input",
          function (
            event
          ) {

            setHeightMultiplier(
              Number(
                event.target.value
              )
            );

          }
        );


      return controls;
    }


    const heightControls =
      createHeightControls();


    function setHeightMultiplier(
      value
    ) {

      value =
        Math.max(
          1,
          Math.min(
            4,
            Number(
              value
            )
          )
        );


      value =
        Math.round(
          value *
          2
        ) /
        2;


      heightMultiplier =
        value;


      heightControls
        .querySelector(
          ".terrain-height-slider"
        )
        .value =
          String(
            value
          );


      heightControls
        .querySelector(
          ".terrain-height-value"
        )
        .textContent =
          value.toFixed(
            value % 1 === 0
              ? 0
              : 1
          )
          +
          "×";


      if (
        window.selectedTerrain
      ) {

        window.selectedTerrain
          .heightMultiplier =
            value;

      }


      saveState();
    }


    function getOrientedDimensions() {

      if (
        orientation ===
        "portrait"
      ) {

        return {
          width:
            modelHeightMm,

          height:
            modelWidthMm
        };

      }


      return {
        width:
          modelWidthMm,

        height:
          modelHeightMm
      };
    }


    function updateTargetRatio() {

      if (
        !modelWidthMm
        ||
        !modelHeightMm
      ) {

        targetRatio =
          null;

        return;
      }


      const dimensions =
        getOrientedDimensions();


      targetRatio =
        dimensions.width /
        dimensions.height;
    }


    function updateOrientationButtons() {

      orientationControls
        .querySelectorAll(
          ".terrain-orientation-button"
        )
        .forEach(
          function (
            button
          ) {

            button.classList.toggle(
              "selected",
              button.dataset.orientation ===
                orientation
            );

          }
        );
    }


    function updateSizeSummary() {

      if (
        !selectedSize
        ||
        !modelWidthMm
        ||
        !modelHeightMm
      ) {
        return;
      }


      const dimensions =
        getOrientedDimensions();


      selectedSizeOutput.textContent =
        selectedSize
        +
        " — "
        +
        (
          dimensions.width /
          10
        ).toFixed(
          0
        )
        +
        " × "
        +
        (
          dimensions.height /
          10
        ).toFixed(
          0
        )
        +
        " cm";


      selectedPriceOutput.textContent =
        selectedPrice > 0 ? "$" + selectedPrice : "Price pending";
    }


    function normaliseAngle(
      value
    ) {

      let angle =
        Number(
          value
        )
        ||
        0;


      while (
        angle <=
        -180
      ) {

        angle +=
          360;

      }


      while (
        angle >
        180
      ) {

        angle -=
          360;

      }


      return angle;
    }


    function getSelectionGeometry() {

      if (
        !selectionCorners
        ||
        selectionCorners.length !==
          4
      ) {

        return null;
      }


      const points =
        selectionCorners.map(
          function (
            corner
          ) {

            return map.latLngToLayerPoint(
              corner
            );

          }
        );


      const centre =
        L.point(
          (
            points[0].x
            +
            points[1].x
            +
            points[2].x
            +
            points[3].x
          )
          /
          4,

          (
            points[0].y
            +
            points[1].y
            +
            points[2].y
            +
            points[3].y
          )
          /
          4
        );


      const width =
        Math.max(
          Math.hypot(
            points[1].x -
              points[0].x,

            points[1].y -
              points[0].y
          ),
          1
        );


      const height =
        Math.max(
          Math.hypot(
            points[3].x -
              points[0].x,

            points[3].y -
              points[0].y
          ),
          1
        );


      const angle =
        Math.atan2(
          points[1].y -
            points[0].y,

          points[1].x -
            points[0].x
        );


      return {
        points:
          points,

        centre:
          centre,

        width:
          width,

        height:
          height,

        angle:
          angle
      };
    }


    function buildCorners(
      centre,
      width,
      height,
      angle
    ) {

      const ux =
        Math.cos(
          angle
        );

      const uy =
        Math.sin(
          angle
        );

      const vx =
        -Math.sin(
          angle
        );

      const vy =
        Math.cos(
          angle
        );


      const halfWidth =
        width /
        2;

      const halfHeight =
        height /
        2;


      return [
        [-1, -1],
        [1, -1],
        [1, 1],
        [-1, 1]
      ]
        .map(
          function (
            sign
          ) {

            return map.layerPointToLatLng(
              L.point(
                centre.x
                +
                sign[0]
                *
                halfWidth
                *
                ux
                +
                sign[1]
                *
                halfHeight
                *
                vx,

                centre.y
                +
                sign[0]
                *
                halfWidth
                *
                uy
                +
                sign[1]
                *
                halfHeight
                *
                vy
              )
            );

          }
        );
    }


    function getCentreLatLng() {

      const geometry =
        getSelectionGeometry();


      return geometry
        ? map.layerPointToLatLng(
            geometry.centre
          )
        : null;
    }


    function getRotationHandleLatLng() {

      const geometry =
        getSelectionGeometry();


      if (
        !geometry
      ) {
        return null;
      }


      const distanceFromCentre =
        geometry.height /
        2
        +
        38;


      const vx =
        -Math.sin(
          geometry.angle
        );

      const vy =
        Math.cos(
          geometry.angle
        );


      return map.layerPointToLatLng(
        L.point(
          geometry.centre.x
          -
          vx *
          distanceFromCentre,

          geometry.centre.y
          -
          vy *
          distanceFromCentre
        )
      );
    }


    function getResizeHintLatLng() {

      const geometry =
        getSelectionGeometry();


      if (
        !geometry
        ||
        !geometry.points
        ||
        !geometry.points.length
      ) {
        return null;
      }


      /*
       * Keep the resize note outside the entire rotated box.
       *
       * Using the box's local rotated edge can make a wide text label
       * swing back across the terrain when the customer rotates it.
       * Instead, position the note above the box's SCREEN-SPACE
       * bounding rectangle. This keeps the wording horizontal and
       * guarantees it stays clear of the selected terrain at any angle.
       */
      const xs =
        geometry.points.map(
          function (
            point
          ) {
            return point.x;
          }
        );


      const ys =
        geometry.points.map(
          function (
            point
          ) {
            return point.y;
          }
        );


      const minX =
        Math.min.apply(
          null,
          xs
        );

      const maxX =
        Math.max.apply(
          null,
          xs
        );

      const minY =
        Math.min.apply(
          null,
          ys
        );

      const maxY =
        Math.max.apply(
          null,
          ys
        );


      const mapSize =
        map.getSize();


      const hintGap =
        24;


      const hintX =
        (
          minX
          +
          maxX
        )
        /
        2;


      /*
       * Normally place it above the box. If there is not enough room
       * near the top of the map, put it below instead.
       */
      const placeBelow =
        minY <
        42;


      const hintY =
        placeBelow
          ? Math.min(
              mapSize.y -
                18,
              maxY +
                hintGap
            )
          : Math.max(
              18,
              minY -
                hintGap
            );


      return map.layerPointToLatLng(
        L.point(
          hintX,
          hintY
        )
      );
    }


    const selectionHelp =
      document.createElement(
        "div"
      );


    selectionHelp.className =
      "terrain-selection-help";


    selectionHelp.innerHTML = `

      <strong>
        Adjust your area:
      </strong>

      drag the centre to move,
      <strong>drag any corner handle to make the box larger or smaller</strong>,
      or drag ↻ to rotate.

      <span class="terrain-selection-angle">
        Rotation: 0°
      </span>

      <button
        type="button"
        class="terrain-selection-reset-rotation"
      >
        Reset rotation
      </button>

    `;


    mapElement.insertAdjacentElement(
      "afterend",
      selectionHelp
    );

    // The dedicated studio moves the map outside its scrolling sidebar.
    // Keep the help with the map controls even if that move happened first.
    if (wrapper.dataset.ridgeStudioPage === "true" && mapElement.parentElement === wrapper) {
      mapStep.appendChild(selectionHelp);
    }


    const angleOutput =
      selectionHelp.querySelector(
        ".terrain-selection-angle"
      );


    const resetRotationButton =
      selectionHelp.querySelector(
        ".terrain-selection-reset-rotation"
      );


    function makeHandleIcon(
      kind,
      index
    ) {

      let html =
        '<div class="terrain-selection-corner-handle corner-'
        +
        String(index || 0)
        +
        '"></div>';


      let size =
        [26, 26];


      let anchor =
        [13, 13];


      if (
        kind ===
        "centre"
      ) {

        html =
          '<div class="terrain-selection-centre-handle">✥</div>';

        size =
          [24, 24];

        anchor =
          [12, 12];

      }


      if (
        kind ===
        "rotation"
      ) {

        html =
          '<div class="terrain-selection-rotation-handle">↻</div>';

        size =
          [24, 24];

        anchor =
          [12, 12];

      }


      return L.divIcon(
        {
          className:
            "terrain-selection-handle-shell",

          html:
            html,

          iconSize:
            size,

          iconAnchor:
            anchor
        }
      );
    }


    function removeHandles() {

      cornerHandles.forEach(
        function (
          handle
        ) {

          map.removeLayer(
            handle
          );

        }
      );


      cornerHandles =
        [];


      if (
        centreHandle
      ) {

        map.removeLayer(
          centreHandle
        );

      }


      if (
        rotationHandle
      ) {

        map.removeLayer(
          rotationHandle
        );

      }


      if (
        rotationLine
      ) {

        map.removeLayer(
          rotationLine
        );

      }


      if (
        resizeHintMarker
      ) {

        map.removeLayer(
          resizeHintMarker
        );

      }


      centreHandle =
        null;

      rotationHandle =
        null;

      rotationLine =
        null;

      resizeHintMarker =
        null;
    }


    function updateAngleOutput() {

      selectionRotationDegrees =
        normaliseAngle(
          selectionRotationDegrees
        );


      angleOutput.textContent =
        "Rotation: "
        +
        selectionRotationDegrees.toFixed(
          1
        )
        +
        "°";
    }


    function updateSelectionLayers(
      activeHandle
    ) {

      if (
        !selectionCorners
        ||
        selectionCorners.length !==
          4
      ) {
        return;
      }


      if (
        !selectionPolygon
      ) {

        selectionPolygon =
          L.polygon(
            selectionCorners,
            {
              className:
                "ridge-selection-outline",
              color:
                "#111",

              weight:
                2,

              fillOpacity:
                0.15
            }
          )
          .addTo(
            map
          );

      } else {

        selectionPolygon.setLatLngs(
          selectionCorners
        );

      }


      const centreLatLng =
        getCentreLatLng();


      const rotationLatLng =
        getRotationHandleLatLng();


      cornerHandles.forEach(
        function (
          handle,
          index
        ) {

          if (
            handle !==
            activeHandle
          ) {

            handle.setLatLng(
              selectionCorners[
                index
              ]
            );

          }

        }
      );


      if (
        centreHandle
        &&
        centreHandle !==
          activeHandle
        &&
        centreLatLng
      ) {

        centreHandle.setLatLng(
          centreLatLng
        );

      }


      if (
        rotationHandle
        &&
        rotationHandle !==
          activeHandle
        &&
        rotationLatLng
      ) {

        rotationHandle.setLatLng(
          rotationLatLng
        );

      }


      if (
        rotationLine
        &&
        centreLatLng
        &&
        rotationLatLng
      ) {

        rotationLine.setLatLngs(
          [
            centreLatLng,
            rotationLatLng
          ]
        );

      }


      if (
        resizeHintMarker
      ) {

        const hintLatLng =
          getResizeHintLatLng();


        if (
          hintLatLng
        ) {

          resizeHintMarker.setLatLng(
            hintLatLng
          );

        }

      }


      updateAngleOutput();
    }


    function resizeFromCorner(
      index,
      pointerLatLng
    ) {

      const geometry =
        getSelectionGeometry();


      if (
        !geometry
        ||
        !targetRatio
      ) {
        return;
      }


      const oppositeIndex =
        (
          index +
          2
        )
        %
        4;


      const opposite =
        map.latLngToLayerPoint(
          selectionCorners[
            oppositeIndex
          ]
        );


      const pointer =
        map.latLngToLayerPoint(
          pointerLatLng
        );


      const ux =
        Math.cos(
          geometry.angle
        );

      const uy =
        Math.sin(
          geometry.angle
        );

      const vx =
        -Math.sin(
          geometry.angle
        );

      const vy =
        Math.cos(
          geometry.angle
        );


      const dx =
        pointer.x -
        opposite.x;

      const dy =
        pointer.y -
        opposite.y;


      let width =
        Math.max(
          Math.abs(
            dx * ux
            +
            dy * uy
          ),
          24
        );


      let height =
        Math.max(
          Math.abs(
            dx * vx
            +
            dy * vy
          ),
          24
        );


      if (
        width /
        height >
        targetRatio
      ) {

        height =
          width /
          targetRatio;

      } else {

        width =
          height *
          targetRatio;

      }


      const signs =
        [
          [-1, -1],
          [1, -1],
          [1, 1],
          [-1, 1]
        ];


      const sign =
        signs[
          index
        ];


      const dragged =
        L.point(
          opposite.x
          +
          sign[0]
          *
          width
          *
          ux
          +
          sign[1]
          *
          height
          *
          vx,

          opposite.y
          +
          sign[0]
          *
          width
          *
          uy
          +
          sign[1]
          *
          height
          *
          vy
        );


      const centre =
        L.point(
          (
            opposite.x
            +
            dragged.x
          )
          /
          2,

          (
            opposite.y
            +
            dragged.y
          )
          /
          2
        );


      selectionCorners =
        buildCorners(
          centre,
          width,
          height,
          geometry.angle
        );
    }


    function createHandles() {

      removeHandles();


      if (
        !selectionCorners
        ||
        selectionCorners.length !==
          4
      ) {
        return;
      }


      cornerHandles =
        selectionCorners.map(
          function (
            corner,
            index
          ) {

            const marker =
              L.marker(
                corner,
                {
                  icon:
                    makeHandleIcon(
                      "corner",
                      index
                    ),

                  draggable:
                    true,

                  keyboard:
                    false,

                  zIndexOffset:
                    1200
                }
              )
              .addTo(
                map
              );


            marker.on(
              "dragstart",
              function () {

                map.dragging.disable();

              }
            );


            marker.on(
              "drag",
              function (
                event
              ) {

                resizeFromCorner(
                  index,
                  event.target
                    .getLatLng()
                );


                updateSelectionLayers(
                  marker
                );

              }
            );


            marker.on(
              "dragend",
              function () {

                updateSelectionLayers();

                updateInformation();

                map.dragging.enable();

              }
            );


            return marker;
          }
        );


      centreHandle =
        L.marker(
          getCentreLatLng(),
          {
            icon:
              makeHandleIcon(
                "centre"
              ),

            draggable:
              true,

            keyboard:
              false,

            zIndexOffset:
              1100
          }
        )
        .addTo(
          map
        );


      let centreStart =
        null;


      let cornerStartPoints =
        null;


      centreHandle.on(
        "dragstart",
        function () {

          map.dragging.disable();


          centreStart =
            map.latLngToLayerPoint(
              centreHandle.getLatLng()
            );


          cornerStartPoints =
            selectionCorners.map(
              function (
                corner
              ) {

                return map.latLngToLayerPoint(
                  corner
                );

              }
            );

        }
      );


      centreHandle.on(
        "drag",
        function () {

          if (
            !centreStart
            ||
            !cornerStartPoints
          ) {
            return;
          }


          const current =
            map.latLngToLayerPoint(
              centreHandle.getLatLng()
            );


          const delta =
            L.point(
              current.x -
                centreStart.x,

              current.y -
                centreStart.y
            );


          selectionCorners =
            cornerStartPoints.map(
              function (
                point
              ) {

                return map.layerPointToLatLng(
                  L.point(
                    point.x +
                      delta.x,

                    point.y +
                      delta.y
                  )
                );

              }
            );


          updateSelectionLayers(
            centreHandle
          );

        }
      );


      centreHandle.on(
        "dragend",
        function () {

          centreStart =
            null;

          cornerStartPoints =
            null;


          updateSelectionLayers();

          updateInformation();

          map.dragging.enable();

        }
      );


      rotationHandle =
        L.marker(
          getRotationHandleLatLng(),
          {
            icon:
              makeHandleIcon(
                "rotation"
              ),

            draggable:
              true,

            keyboard:
              false,

            zIndexOffset:
              1300
          }
        )
        .addTo(
          map
        );


      rotationHandle.on(
        "dragstart",
        function () {

          map.dragging.disable();

        }
      );


      rotationHandle.on(
        "drag",
        function () {

          const geometry =
            getSelectionGeometry();


          if (
            !geometry
          ) {
            return;
          }


          const pointer =
            map.latLngToLayerPoint(
              rotationHandle.getLatLng()
            );


          const pointerAngle =
            Math.atan2(
              pointer.y -
                geometry.centre.y,

              pointer.x -
                geometry.centre.x
            );


          selectionRotationDegrees =
            normaliseAngle(
              (
                pointerAngle
                +
                Math.PI /
                2
              )
              *
              180
              /
              Math.PI
            );


          const newAngle =
            selectionRotationDegrees
            *
            Math.PI
            /
            180;


          selectionCorners =
            buildCorners(
              geometry.centre,
              geometry.width,
              geometry.height,
              newAngle
            );


          updateSelectionLayers(
            rotationHandle
          );

        }
      );


      rotationHandle.on(
        "dragend",
        function () {

          updateSelectionLayers();

          updateInformation();

          map.dragging.enable();

        }
      );


      rotationLine =
        L.polyline(
          [
            getCentreLatLng(),
            getRotationHandleLatLng()
          ],
          {
            color:
              "#111",

            weight:
              1,

            dashArray:
              "3,4",

            interactive:
              false
          }
        )
        .addTo(
          map
        );


      resizeHintMarker =
        L.marker(
          getResizeHintLatLng(),
          {
            icon:
              L.divIcon({
                className:
                  "terrain-selection-resize-hint-shell",

                html:
                  '<div class="terrain-selection-resize-hint">Drag corners to resize</div>',

                iconSize:
                  [1, 1],

                iconAnchor:
                  [0, 0]
              }),

            interactive:
              false,

            keyboard:
              false,

            zIndexOffset:
              1000
          }
        )
        .addTo(
          map
        );


      rotationLine.bringToBack();


      selectionHelp.classList.add(
        "is-visible"
      );


      updateSelectionLayers();
    }


    function clearSelection() {

      if (
        selectionPolygon
      ) {

        map.removeLayer(
          selectionPolygon
        );


        selectionPolygon =
          null;
      }


      removeHandles();


      selectionCorners =
        null;


      selectionRotationDegrees =
        0;


      selectionHelp.classList.remove(
        "is-visible"
      );


      window.selectedTerrain =
        null;
    }


    function rotateExistingSelectionToRatio() {

      const geometry =
        getSelectionGeometry();


      if (
        !geometry
        ||
        !targetRatio
      ) {
        return;
      }


      const pixelArea =
        Math.max(
          geometry.width
          *
          geometry.height,
          1
        );


      const newWidth =
        Math.sqrt(
          pixelArea
          *
          targetRatio
        );


      const newHeight =
        Math.sqrt(
          pixelArea
          /
          targetRatio
        );


      selectionCorners =
        buildCorners(
          geometry.centre,
          newWidth,
          newHeight,
          geometry.angle
        );


      createHandles();

      updateInformation();
    }


    function setOrientation(
      newOrientation
    ) {

      if (
        !selectedSize
        ||
        modelWidthMm ===
          modelHeightMm
      ) {
        return;
      }


      orientation =
        newOrientation;


      updateTargetRatio();

      updateOrientationButtons();

      updateSizeSummary();


      if (
        selectionCorners
      ) {

        rotateExistingSelectionToRatio();

      }


      saveState();
    }


    resetRotationButton.addEventListener(
      "click",
      function () {

        const geometry =
          getSelectionGeometry();


        if (
          !geometry
        ) {
          return;
        }


        selectionRotationDegrees =
          0;


        selectionCorners =
          buildCorners(
            geometry.centre,
            geometry.width,
            geometry.height,
            0
          );


        createHandles();

        updateInformation();

      }
    );


    map.on(
      "zoomend",
      function () {

        if (
          selectionCorners
        ) {

          updateSelectionLayers();

        }

      }
    );


    const searchInputWrapper =
      document.createElement(
        "div"
      );


    searchInputWrapper.className =
      "terrain-search-input-wrapper";


    searchInput.parentNode.insertBefore(
      searchInputWrapper,
      searchInput
    );


    searchInputWrapper.appendChild(
      searchInput
    );


    const searchSuggestions =
      document.createElement(
        "div"
      );


    searchSuggestions.className =
      "terrain-search-suggestions";


    searchSuggestions.setAttribute(
      "role",
      "listbox"
    );


    searchInputWrapper.appendChild(
      searchSuggestions
    );


    let searchTimer =
      null;

    let searchRequest =
      0;

    let currentSuggestions =
      [];

    let activeSuggestion =
      -1;


    function cleanSearchPart(
      value
    ) {

      return value == null
        ? ""
        : String(
            value
          ).trim();
    }


    function uniqueSearchParts(
      values
    ) {

      const seen =
        new Set();


      return values
        .map(
          cleanSearchPart
        )
        .filter(
          function (
            value
          ) {

            if (
              !value
            ) {
              return false;
            }


            const key =
              value.toLowerCase();


            if (
              seen.has(
                key
              )
            ) {

              return false;

            }


            seen.add(
              key
            );


            return true;
          }
        );
    }


    function getSearchText(
      feature
    ) {

      const p =
        feature.properties
        ||
        {};


      const name =
        cleanSearchPart(
          p.name
        )
        ||
        cleanSearchPart(
          p.street
        )
        ||
        cleanSearchPart(
          p.city
        )
        ||
        cleanSearchPart(
          p.state
        )
        ||
        cleanSearchPart(
          p.country
        )
        ||
        "Location";


      const details =
        uniqueSearchParts(
          [
            p.street !== name
              ? p.street
              : "",

            p.locality,

            p.district,

            p.city !== name
              ? p.city
              : "",

            p.county,

            p.state !== name
              ? p.state
              : "",

            p.country !== name
              ? p.country
              : ""
          ]
        );


      return {
        name:
          name,

        details:
          details.join(
            ", "
          ),

        full:
          uniqueSearchParts(
            [
              name
            ]
            .concat(
              details
            )
          )
          .join(
            ", "
          )
      };
    }


    function getSearchZoom(
      feature
    ) {

      const layer =
        cleanSearchPart(
          feature.properties
          &&
          feature.properties.layer
        )
        .toLowerCase();


      if (
        layer ===
        "house"
      ) {
        return 17;
      }


      if (
        layer ===
        "street"
      ) {
        return 16;
      }


      if (
        layer ===
        "locality"
        ||
        layer ===
        "district"
      ) {
        return 14;
      }


      if (
        layer ===
        "city"
      ) {
        return 12;
      }


      if (
        layer ===
        "county"
      ) {
        return 10;
      }


      if (
        layer ===
        "state"
      ) {
        return 7;
      }


      if (
        layer ===
        "country"
      ) {
        return 5;
      }


      return 13;
    }


    function closeSuggestions() {

      currentSuggestions =
        [];


      activeSuggestion =
        -1;


      searchSuggestions.innerHTML =
        "";


      searchSuggestions.classList.remove(
        "is-open"
      );


      searchInput.setAttribute(
        "aria-expanded",
        "false"
      );
    }


    function updateActiveSuggestion() {

      searchSuggestions
        .querySelectorAll(
          ".terrain-search-suggestion"
        )
        .forEach(
          function (
            button,
            index
          ) {

            button.classList.toggle(
              "is-active",
              index ===
                activeSuggestion
            );

          }
        );
    }


    function chooseSuggestion(
      feature
    ) {

      if (
        !feature
        ||
        !feature.geometry
        ||
        !Array.isArray(
          feature.geometry.coordinates
        )
      ) {
        return;
      }


      const lon =
        Number(
          feature.geometry.coordinates[
            0
          ]
        );


      const lat =
        Number(
          feature.geometry.coordinates[
            1
          ]
        );


      if (
        !Number.isFinite(
          lat
        )
        ||
        !Number.isFinite(
          lon
        )
      ) {
        return;
      }


      searchInput.value =
        getSearchText(
          feature
        ).full;


      closeSuggestions();


      map.setView(
        [
          lat,
          lon
        ],
        getSearchZoom(
          feature
        )
      );


      lastSearchLatLng = L.latLng(lat, lon);
      wrapper.dataset.terrainReview='false';
      // Search selects the location and makes a starter box. A printed pin
      // is never created automatically.
      if(selectedSize) createStarterSelection(lastSearchLatLng,false);
      if (terrainMarkers.length && selectionCorners) updateInformation();
      updatePointControls();
      saveState();


      searchInput.blur();
    }


    function renderSuggestions(
      features
    ) {

      currentSuggestions =
        features.slice(
          0,
          5
        );


      activeSuggestion =
        -1;


      searchSuggestions.innerHTML =
        "";


      if (
        !currentSuggestions.length
      ) {

        closeSuggestions();

        return;
      }


      currentSuggestions.forEach(
        function (
          feature,
          index
        ) {

          const text =
            getSearchText(
              feature
            );


          const button =
            document.createElement(
              "button"
            );


          button.type =
            "button";


          button.className =
            "terrain-search-suggestion";


          const name =
            document.createElement(
              "span"
            );


          name.className =
            "terrain-search-suggestion-name";


          name.textContent =
            text.name;


          button.appendChild(
            name
          );


          if (
            text.details
          ) {

            const details =
              document.createElement(
                "span"
              );


            details.className =
              "terrain-search-suggestion-details";


            details.textContent =
              text.details;


            button.appendChild(
              details
            );

          }


          button.addEventListener(
            "mouseenter",
            function () {

              activeSuggestion =
                index;


              updateActiveSuggestion();

            }
          );


          button.addEventListener(
            "mousedown",
            function (
              event
            ) {

              event.preventDefault();

            }
          );


          button.addEventListener(
            "click",
            function () {

              chooseSuggestion(
                feature
              );

            }
          );


          searchSuggestions.appendChild(
            button
          );

        }
      );


      searchSuggestions.classList.add(
        "is-open"
      );


      searchInput.setAttribute(
        "aria-expanded",
        "true"
      );
    }


    async function fetchSuggestions(
      query
    ) {

      const requestNumber =
        ++searchRequest;


      try {

        const url =
          "https://photon.komoot.io/api/?"
          +
          new URLSearchParams(
            {
              q:
                query,

              limit:
                "5",

              lang:
                "en"
            }
          ).toString();


        const response =
          await fetch(
            url,
            {
              headers:
                {
                  Accept:
                    "application/json"
                }
            }
          );


        if (
          !response.ok
        ) {

          throw new Error(
            "Search request failed"
          );

        }


        const data =
          await response.json();


        if (
          requestNumber !==
          searchRequest
        ) {

          return [];

        }


        return Array.isArray(
          data.features
        )
          ? data.features
          : [];


      } catch (
        error
      ) {

        if (
          requestNumber ===
          searchRequest
        ) {

          closeSuggestions();

        }


        return [];
      }
    }


    async function loadSuggestions() {

      const query =
        searchInput.value.trim();


      if (
        query.length <
        3
      ) {

        closeSuggestions();

        return;
      }


      const features =
        await fetchSuggestions(
          query
        );


      if (
        searchInput.value.trim() !==
        query
      ) {
        return;
      }


      renderSuggestions(
        features
      );
    }


    async function searchLocation() {

      const query =
        searchInput.value.trim();


      if (
        !query
      ) {
        return;
      }


      clearTimeout(
        searchTimer
      );


      closeSuggestions();


      searchButton.disabled =
        true;


      searchButton.textContent =
        "Searching...";


      try {

        const features =
          await fetchSuggestions(
            query
          );


        if (
          features.length
        ) {

          chooseSuggestion(
            features[0]
          );

        }


      } finally {

        searchButton.disabled =
          false;


        searchButton.textContent =
          "Search";

      }
    }


    searchButton.addEventListener(
      "click",
      searchLocation
    );


    searchInput.addEventListener(
      "input",
      function () {

        clearTimeout(
          searchTimer
        );


        searchRequest++;


        const query =
          searchInput.value.trim();


        if (
          query.length <
          3
        ) {

          closeSuggestions();

          return;
        }


        searchTimer =
          setTimeout(
            loadSuggestions,
            350
          );

      }
    );


    searchInput.addEventListener(
      "keydown",
      function (
        event
      ) {

        const open =
          searchSuggestions
            .classList
            .contains(
              "is-open"
            );


        if (
          event.key ===
            "ArrowDown"
          &&
          open
          &&
          currentSuggestions.length
        ) {

          event.preventDefault();


          activeSuggestion =
            (
              activeSuggestion +
              1
            )
            %
            currentSuggestions.length;


          updateActiveSuggestion();

          return;
        }


        if (
          event.key ===
            "ArrowUp"
          &&
          open
          &&
          currentSuggestions.length
        ) {

          event.preventDefault();


          activeSuggestion =
            activeSuggestion <=
              0
              ? currentSuggestions.length -
                1
              : activeSuggestion -
                1;


          updateActiveSuggestion();

          return;
        }


        if (
          event.key ===
          "Escape"
        ) {

          closeSuggestions();

          return;
        }


        if (
          event.key ===
          "Enter"
        ) {

          event.preventDefault();


          if (
            open
            &&
            activeSuggestion >=
              0
            &&
            currentSuggestions[
              activeSuggestion
            ]
          ) {

            chooseSuggestion(
              currentSuggestions[
                activeSuggestion
              ]
            );

          } else {

            searchLocation();

          }
        }
      }
    );


    document.addEventListener(
      "click",
      function (
        event
      ) {

        if (
          !searchInputWrapper.contains(
            event.target
          )
        ) {

          closeSuggestions();

        }

      }
    );


    sizeOptions.forEach(
      function (
        option
      ) {

        option.addEventListener(
          "click",
          function () {

            sizeOptions.forEach(
              function (
                otherOption
              ) {

                otherOption.classList.remove(
                  "selected"
                );

              }
            );


            option.classList.add(
              "selected"
            );


            selectedSize =
              option.dataset.size;


            selectedPrice =
              Number(
                option.dataset.price
              );


            modelWidthMm =
              Number(
                option.dataset.modelWidth
              );


            modelHeightMm =
              Number(
                option.dataset.modelHeight
              );


            /*
             * Keep the customer's height boost when changing size.
             * Only initialise it to 1.5× on the very first size choice.
             */
            setHeightMultiplier(
              Number.isFinite(
                Number(heightMultiplier)
              )
                ? heightMultiplier
                : 1.5
            );


            heightControls.style.display =
              "block";


            if (
              modelWidthMm ===
              modelHeightMm
            ) {

              orientation =
                "square";


              orientationControls.style.display =
                "none";

            } else {

              /*
               * Preserve portrait/landscape when possible.
               */
              orientation =
                orientation === "portrait"
                  ? "portrait"
                  : "landscape";


              orientationControls.style.display =
                "block";

            }


            updateTargetRatio();

            updateOrientationButtons();

            updateSizeSummary();


            sizeSummary.style.display =
              "grid";


            selectButton.disabled = false;


            selectButton.classList.remove(
              "is-active"
            );

            selectButton.setAttribute(
              "aria-pressed",
              "false"
            );

            selectButton.textContent =
              "Draw area";


            /*
             * Do not wipe the map selection when changing size.
             * Keep its centre/rotation/area and reshape it to the
             * new product aspect ratio.
             */
            if (
              selectionCorners
            ) {

              rotateExistingSelectionToRatio();

            } else if (lastSearchLatLng) {
              createStarterSelection(lastSearchLatLng, false);
            }


            selectedBox.style.display =
              selectionCorners
                ? "block"
                : "none";


            emptyBox.style.display =
              selectionCorners
                ? "none"
                : "flex";


            const strong =
              emptyBox.querySelector(
                "strong"
              );


            const span =
              emptyBox.querySelector(
                "span"
              );


            if (
              strong
            ) {

              strong.textContent =
                selectionCorners
                  ? "Your area is ready to adjust"
                  : "Search for a place to choose the terrain area";

            }


            if (
              span
            ) {

              span.textContent =
                selectionCorners
                  ? "Drag the corner arrows to increase or decrease the selected area, then generate your framed preview."
                  : "A selection box appears when you search, or use Draw area to make your own.";

            }


            updatePointControls();
            saveState();


            /*
             * After choosing a size, take the customer straight
             * to the Search location / map section.
             * Do not focus the input so mobile keyboards stay closed.
             */
            setTimeout(
              function () {

                if (
                  mapStep
                ) {

                  if (wrapper.dataset.ridgeStudioPage === "true" && window.innerWidth >= 990) {
                    wrapper.querySelector(".ridge-studio-sidebar")?.scrollTo({top: 0, behavior: "instant"});
                  } else {
                    mapStep.scrollIntoView({behavior: "smooth", block: "start"});
                  }

                }


                map.invalidateSize();

              },
              120
            );

          }
        );

      }
    );


    selectButton.addEventListener(
      "click",
      function () {

        if (
          !selectedSize
          ||
          !targetRatio
        ) {
          updatePointControls();
          return;
        }


        drawing =
          !drawing;


        if (
          drawing
        ) {

          clearSelection();


          selectButton.classList.add(
            "is-active"
          );

          selectButton.setAttribute(
            "aria-pressed",
            "true"
          );

          selectButton.textContent =
            "Drag on map";


          map.dragging.disable();


          map.getContainer().style.cursor =
            "crosshair";

        } else {

          stopDrawing();

        }

      }
    );


    map.on(
      "mousedown",
      function (
        event
      ) {

        if (
          !drawing
          ||
          !targetRatio
        ) {
          return;
        }


        drawStartLatLng =
          event.latlng;


        selectionRotationDegrees =
          0;


        selectionCorners =
          [
            drawStartLatLng,
            drawStartLatLng,
            drawStartLatLng,
            drawStartLatLng
          ];


        selectionPolygon =
          L.polygon(
            selectionCorners,
            {
              className:
                "ridge-selection-outline",
              color:
                "#111",

              weight:
                2,

              fillOpacity:
                0.15
            }
          )
          .addTo(
            map
          );

      }
    );


    map.on(
      "mousemove",
      function (
        event
      ) {

        if (
          !drawing
          ||
          !drawStartLatLng
          ||
          !selectionPolygon
          ||
          !targetRatio
        ) {
          return;
        }


        selectionCorners =
          getInitialCorners(
            drawStartLatLng,
            event.latlng,
            targetRatio
          );


        selectionPolygon.setLatLngs(
          selectionCorners
        );

      }
    );


    map.on(
      "mouseup",
      function (
        event
      ) {

        if (
          !drawing
          ||
          !drawStartLatLng
          ||
          !selectionPolygon
          ||
          !targetRatio
        ) {
          return;
        }


        selectionCorners =
          getInitialCorners(
            drawStartLatLng,
            event.latlng,
            targetRatio
          );


        selectionPolygon.setLatLngs(
          selectionCorners
        );


        stopDrawing();


        createHandles();


        updateInformation();

      }
    );


    function getInitialCorners(
      startLatLng,
      currentLatLng,
      ratio
    ) {

      const start =
        map.latLngToLayerPoint(
          startLatLng
        );


      const current =
        map.latLngToLayerPoint(
          currentLatLng
        );


      let dx =
        current.x -
        start.x;


      let dy =
        current.y -
        start.y;


      const signX =
        dx < 0
          ? -1
          : 1;


      const signY =
        dy < 0
          ? -1
          : 1;


      const absX =
        Math.abs(
          dx
        );


      const absY =
        Math.abs(
          dy
        );


      if (
        absX <
          2
        &&
        absY <
          2
      ) {

        dx =
          signX *
          24;


        dy =
          signY *
          (
            24 /
            ratio
          );

      } else if (
        absY ===
          0
        ||
        absX /
          Math.max(
            absY,
            0.0001
          )
          >
          ratio
      ) {

        dy =
          signY *
          (
            absX /
            ratio
          );

      } else {

        dx =
          signX *
          (
            absY *
            ratio
          );

      }


      const end =
        L.point(
          start.x +
            dx,

          start.y +
            dy
        );


      const left =
        Math.min(
          start.x,
          end.x
        );


      const right =
        Math.max(
          start.x,
          end.x
        );


      const top =
        Math.min(
          start.y,
          end.y
        );


      const bottom =
        Math.max(
          start.y,
          end.y
        );


      return [
        map.layerPointToLatLng(
          L.point(
            left,
            top
          )
        ),

        map.layerPointToLatLng(
          L.point(
            right,
            top
          )
        ),

        map.layerPointToLatLng(
          L.point(
            right,
            bottom
          )
        ),

        map.layerPointToLatLng(
          L.point(
            left,
            bottom
          )
        )
      ];
    }


    function stopDrawing() {

      drawing =
        false;


      drawStartLatLng =
        null;


      selectButton.classList.remove(
        "is-active"
      );


      selectButton.setAttribute(
        "aria-pressed",
        "false"
      );


      selectButton.textContent =
        selectionCorners
          ? "Draw area"
          : "Draw area";


      map.dragging.enable();


      map.getContainer().style.cursor =
        "";
    }


    function updateInformation() {

      if (
        !selectionCorners
        ||
        selectionCorners.length !==
          4
      ) {
        return;
      }

      // Marker coordinates are absolute and deliberately NEVER adjusted here.
      // Moving, resizing, rotating or redrawing the selection changes only
      // the selection box; markers remain fixed until dragged or re-centred.

      const latitudes =
        selectionCorners.map(
          function (
            corner
          ) {

            return corner.lat;

          }
        );


      const longitudes =
        selectionCorners.map(
          function (
            corner
          ) {

            return corner.lng;

          }
        );


      const north =
        Math.max.apply(
          Math,
          latitudes
        );


      const south =
        Math.min.apply(
          Math,
          latitudes
        );


      const east =
        Math.max.apply(
          Math,
          longitudes
        );


      const west =
        Math.min.apply(
          Math,
          longitudes
        );


      const width =
        (
          map.distance(
            selectionCorners[0],
            selectionCorners[1]
          )
          +
          map.distance(
            selectionCorners[3],
            selectionCorners[2]
          )
        )
        /
        2;


      const height =
        (
          map.distance(
            selectionCorners[0],
            selectionCorners[3]
          )
          +
          map.distance(
            selectionCorners[1],
            selectionCorners[2]
          )
        )
        /
        2;


      const area =
        width *
        height;


      const geometry =
        getSelectionGeometry();


      if (
        geometry
      ) {

        selectionRotationDegrees =
          normaliseAngle(
            geometry.angle
            *
            180
            /
            Math.PI
          );

      }


      updateAngleOutput();


      widthOutput.textContent =
        formatDistance(
          width
        );


      heightOutput.textContent =
        formatDistance(
          height
        );


      areaOutput.textContent =
        formatArea(
          area
        );


      northOutput.textContent =
        north.toFixed(
          7
        );


      southOutput.textContent =
        south.toFixed(
          7
        );


      eastOutput.textContent =
        east.toFixed(
          7
        );


      westOutput.textContent =
        west.toFixed(
          7
        );


      emptyBox.style.display =
        "none";


      selectedBox.style.display =
        "block";


      selectionHelp.classList.add(
        "is-visible"
      );


      const dimensions =
        getOrientedDimensions();


      const allPinsValid=allMarkersValid();
      const markerUVs=allPinsValid ? terrainMarkers.map(entry => {
        const uv=getPointUV(entry);
        return {u:uv.u,v:1-uv.v,colour:detailColour(entry.colour)};
      }) : [];
      window.selectedTerrain =
        {
          // Leaflet box UVs count v from the TOP edge. The preview and
          // paid STL pipeline use the GPX convention: v=0 at the BOTTOM.
          // Convert only at hand-off; map placement and inset checks stay unchanged.
          markers: markerUVs,
          // Backward compatible field for any older scripts reading one pin.
          marker: markerUVs.length ? markerUVs[0] : null,
          locationPoints: allPinsValid ? terrainMarkers.map(entry => ({
            lat:entry.point.lat,lng:entry.point.lng
          })) : [],
          gpxRoutes: mapGpxFiles.map(file => ({
            id:file.id,name:file.name,colour:detailColour(file.colour),segment_count:file.fullSegments.length
          })),
          gpxXml: mapGpx ? mapGpx.xml : null,
          gpxNamePending: mapGpx ? mapGpx.name : null,
          sectionId:
            wrapper.dataset.sectionId,

          north:
            north,

          south:
            south,

          east:
            east,

          west:
            west,

          width:
            width,

          height:
            height,

          area:
            area,

          size:
            selectedSize,

          price:
            selectedPrice,

          orientation:
            orientation,

          heightMultiplier:
            heightMultiplier,

          modelWidthMm:
            dimensions.width,

          modelHeightMm:
            dimensions.height,

          rotationDegrees:
            selectionRotationDegrees,

          corners:
            selectionCorners.map(
              function (
                corner
              ) {

                return {
                  lat:
                    Number(
                      corner.lat
                    ),

                  lng:
                    Number(
                      corner.lng
                    )
                };

              }
            )
        };


      updatePointControls();
      saveState();
    }


    // No second map click needed: checkbox places the pin automatically,
    // and the Leaflet marker remains draggable for precise positioning.


    previewButton.addEventListener(
      "click",
      function () {

        if (
          !window.selectedTerrain
          ||
          !window.selectedTerrain.size
          ||
          !allMarkersValid()
        ) {
          updatePointControls();
          if (!allMarkersValid()) {
            markerPreviewWarning.hidden = false;
            if (wrapper.dataset.ridgeStudioPage === "true" && window.innerWidth >= 990) {
              const sidebar=wrapper.querySelector(".ridge-studio-sidebar");
              if(sidebar) sidebar.scrollTo({top: Math.max(0, markerPreviewWarning.getBoundingClientRect().top - sidebar.getBoundingClientRect().top + sidebar.scrollTop - 60), behavior:"smooth"});
            } else markerPreviewWarning.scrollIntoView({behavior:"smooth",block:"center"});
          }
          return;
        }


        document.dispatchEvent(
         new CustomEvent(
  "terrain",
            {
              detail:
                window.selectedTerrain
            }
          )
        );

      }
    );


    /*
     * Restore an in-progress configurator after an accidental refresh.
     */
    setTimeout(
      restoreSavedState,
      0
    );


    function formatDistance(
      metres
    ) {

      return metres >=
        1000
          ? (
              metres /
              1000
            ).toFixed(
              2
            )
            +
            " km"
          : metres.toFixed(
              0
            )
            +
            " m";
    }


    function formatArea(
      squareMetres
    ) {

      return squareMetres >=
        1000000
          ? (
              squareMetres /
              1000000
            ).toFixed(
              2
            )
            +
            " km²"
          : (
              squareMetres /
              10000
            ).toFixed(
              2
            )
            +
            " ha";
    }
  }


  function initialiseAll() {

    document
      .querySelectorAll(
        ".terrain-map-wrapper"
      )
      .forEach(
        initialiseMap
      );
  }


  if (
    document.readyState ===
    "loading"
  ) {

    document.addEventListener(
      "DOMContentLoaded",
      initialiseAll
    );

  } else {

    initialiseAll();

  }

})();
